var map = {
	"./components/Accordion/components/AccordionHeader/locales/en.json": "16b5",
	"./components/Accordion/components/AccordionHeader/locales/es.json": "fa80",
	"./components/Accordion/components/AccordionHeader/locales/pt.json": "ffdf",
	"./components/AdditionalContentData/locales/en.json": "8504",
	"./components/AdditionalContentData/locales/es.json": "97ce",
	"./components/AdditionalContentData/locales/pt.json": "6a0d",
	"./components/Annotations/locales/en.json": "63d3",
	"./components/Annotations/locales/es.json": "fbcb",
	"./components/Annotations/locales/pt.json": "f0e6",
	"./components/Avatar/locales/en.json": "17b2",
	"./components/Avatar/locales/es.json": "902a",
	"./components/Avatar/locales/pt.json": "011d",
	"./components/AvatarRanking/locales/en.json": "d5f9",
	"./components/AvatarRanking/locales/es.json": "5147",
	"./components/AvatarRanking/locales/pt.json": "7d7e",
	"./components/Banner/locales/en.json": "178c",
	"./components/Banner/locales/es.json": "09df",
	"./components/Banner/locales/pt.json": "e668",
	"./components/BannerPromotions/locales/en.json": "308f",
	"./components/BannerPromotions/locales/es.json": "d295",
	"./components/BannerPromotions/locales/pt.json": "878c",
	"./components/BannerRenewPlan/locales/en.json": "4f3c",
	"./components/BannerRenewPlan/locales/es.json": "5cb0",
	"./components/BannerRenewPlan/locales/pt.json": "2a01",
	"./components/Book/locales/en.json": "be46",
	"./components/Book/locales/es.json": "7f52",
	"./components/Book/locales/pt.json": "05ee",
	"./components/BulletOptions/locales/en.json": "8444",
	"./components/BulletOptions/locales/es.json": "a5246",
	"./components/BulletOptions/locales/pt.json": "019a",
	"./components/ButtonMovie/locales/en.json": "4534",
	"./components/ButtonMovie/locales/es.json": "e507",
	"./components/ButtonMovie/locales/pt.json": "7dc8",
	"./components/ButtonReportProblem/components/UploadImageSection/locales/en.json": "80e9",
	"./components/ButtonReportProblem/components/UploadImageSection/locales/es.json": "2a3a",
	"./components/ButtonReportProblem/components/UploadImageSection/locales/pt.json": "0c6e",
	"./components/ButtonReportProblem/locales/en.json": "f9a3",
	"./components/ButtonReportProblem/locales/es.json": "b373",
	"./components/ButtonReportProblem/locales/pt.json": "e19b",
	"./components/Calendar/locales/en.json": "7d7c",
	"./components/Calendar/locales/es.json": "c817",
	"./components/Calendar/locales/pt.json": "a2cf",
	"./components/CardProduct/locales/en.json": "f40d",
	"./components/CardProduct/locales/es.json": "f290",
	"./components/CardProduct/locales/pt.json": "26b2",
	"./components/Comments/components/locales/en.json": "4afd",
	"./components/Comments/components/locales/es.json": "1c26",
	"./components/Comments/components/locales/pt.json": "da6f9",
	"./components/Comments/locales/en.json": "5eeb",
	"./components/Comments/locales/es.json": "ae1b",
	"./components/Comments/locales/pt.json": "2e5b",
	"./components/ContainerTutorial/locales/en.json": "c1d1",
	"./components/ContainerTutorial/locales/es.json": "a09c",
	"./components/ContainerTutorial/locales/pt.json": "a1c2",
	"./components/ContainerVideos/locales/en.json": "0ca7",
	"./components/ContainerVideos/locales/es.json": "9a7a",
	"./components/ContainerVideos/locales/pt.json": "d57f",
	"./components/CreditBox/components/CreditInformation/locales/en.json": "c9fb",
	"./components/CreditBox/components/CreditInformation/locales/es.json": "6df7",
	"./components/CreditBox/components/CreditInformation/locales/pt.json": "e905",
	"./components/CreditBox/locales/en.json": "6548",
	"./components/CreditBox/locales/es.json": "b25c",
	"./components/CreditBox/locales/pt.json": "c02a",
	"./components/CropImage/locales/en.json": "66ba",
	"./components/CropImage/locales/es.json": "dd23",
	"./components/CropImage/locales/pt.json": "e0bb",
	"./components/CustomerService/locales/en.json": "9cde",
	"./components/CustomerService/locales/es.json": "e14a",
	"./components/CustomerService/locales/pt.json": "c1a8",
	"./components/DataFilters/locales/en.json": "2080",
	"./components/DataFilters/locales/es.json": "1e47",
	"./components/DataFilters/locales/pt.json": "1185",
	"./components/Doubts/FeedbackDoubtsPlanFree/locales/en.json": "47c0",
	"./components/Doubts/FeedbackDoubtsPlanFree/locales/es.json": "445e",
	"./components/Doubts/FeedbackDoubtsPlanFree/locales/pt.json": "7017",
	"./components/Doubts/FeedbackModal/locales/en.json": "0f40",
	"./components/Doubts/FeedbackModal/locales/es.json": "9bf1",
	"./components/Doubts/FeedbackModal/locales/pt.json": "0b15",
	"./components/Doubts/ListDoubts/locales/en.json": "e10d",
	"./components/Doubts/ListDoubts/locales/es.json": "b33e",
	"./components/Doubts/ListDoubts/locales/pt.json": "946e",
	"./components/Doubts/ModalDisciplineUnavailable/locales/en.json": "42f1",
	"./components/Doubts/ModalDisciplineUnavailable/locales/es.json": "689c",
	"./components/Doubts/ModalDisciplineUnavailable/locales/pt.json": "b7b2",
	"./components/Doubts/SendDoubts/locales/en.json": "f244",
	"./components/Doubts/SendDoubts/locales/es.json": "1308",
	"./components/Doubts/SendDoubts/locales/pt.json": "deea",
	"./components/ErrorLoading/locales/en.json": "9a30",
	"./components/ErrorLoading/locales/es.json": "4ddf",
	"./components/ErrorLoading/locales/pt.json": "d383",
	"./components/ExEditor/locales/en.json": "b86e",
	"./components/ExEditor/locales/es.json": "44c8",
	"./components/ExEditor/locales/pt.json": "f108",
	"./components/ExRichEditor/locales/en.json": "5edd",
	"./components/ExRichEditor/locales/es.json": "aba8",
	"./components/ExRichEditor/locales/pt.json": "2851",
	"./components/Exercise/ExerciseContainer/Modals/locales/en.json": "1e02",
	"./components/Exercise/ExerciseContainer/Modals/locales/es.json": "e36e",
	"./components/Exercise/ExerciseContainer/Modals/locales/pt.json": "b871",
	"./components/Exercise/HelpResolution/QuestionHelpResolution/locales/en.json": "3b78",
	"./components/Exercise/HelpResolution/QuestionHelpResolution/locales/es.json": "e415",
	"./components/Exercise/HelpResolution/QuestionHelpResolution/locales/pt.json": "8204",
	"./components/Exercise/HelpResolution/VideoHelpResolution/locales/en.json": "b6b5",
	"./components/Exercise/HelpResolution/VideoHelpResolution/locales/es.json": "198d",
	"./components/Exercise/HelpResolution/VideoHelpResolution/locales/pt.json": "35e5",
	"./components/Exercise/MapQuestions/locales/en.json": "2c44",
	"./components/Exercise/MapQuestions/locales/es.json": "3bc8",
	"./components/Exercise/MapQuestions/locales/pt.json": "044d",
	"./components/Exercise/NavigationQuestion/locales/en.json": "d512",
	"./components/Exercise/NavigationQuestion/locales/es.json": "3067",
	"./components/Exercise/NavigationQuestion/locales/pt.json": "f698",
	"./components/ExercisePersonalize/locales/en.json": "b88e",
	"./components/ExercisePersonalize/locales/es.json": "fcda",
	"./components/ExercisePersonalize/locales/pt.json": "9a03",
	"./components/ExportButtons/locales/en.json": "907f",
	"./components/ExportButtons/locales/es.json": "78fc",
	"./components/ExportButtons/locales/pt.json": "b128",
	"./components/ExportList/locales/en.json": "4f21",
	"./components/ExportList/locales/es.json": "4c86",
	"./components/ExportList/locales/pt.json": "a248",
	"./components/FeedbackPermission/locales/en.json": "4bf3",
	"./components/FeedbackPermission/locales/es.json": "7d8b",
	"./components/FeedbackPermission/locales/pt.json": "0332",
	"./components/FeedbackRestrictionBooks/CoursesFeedbackRestriction/locales/en.json": "adf5",
	"./components/FeedbackRestrictionBooks/CoursesFeedbackRestriction/locales/es.json": "012e",
	"./components/FeedbackRestrictionBooks/CoursesFeedbackRestriction/locales/pt.json": "b8a8",
	"./components/FeedbackRestrictionBooks/QuestionsFeedbackRestriction/locales/en.json": "8797",
	"./components/FeedbackRestrictionBooks/QuestionsFeedbackRestriction/locales/es.json": "929b",
	"./components/FeedbackRestrictionBooks/QuestionsFeedbackRestriction/locales/pt.json": "d36b",
	"./components/FeedbackRestrictionBooks/SimulatedFeedbackRestriction/locales/en.json": "820f",
	"./components/FeedbackRestrictionBooks/SimulatedFeedbackRestriction/locales/es.json": "70a9",
	"./components/FeedbackRestrictionBooks/SimulatedFeedbackRestriction/locales/pt.json": "effc",
	"./components/FeedbackUser/locales/en.json": "9238",
	"./components/FeedbackUser/locales/es.json": "601a",
	"./components/FeedbackUser/locales/pt.json": "3d5a",
	"./components/FloatingChatButton/locales/en.json": "0c0b",
	"./components/FloatingChatButton/locales/es.json": "1e97",
	"./components/FloatingChatButton/locales/pt.json": "fac6",
	"./components/FloatingHelpButton/locales/en.json": "26cb",
	"./components/FloatingHelpButton/locales/es.json": "e26a",
	"./components/FloatingHelpButton/locales/pt.json": "89e2",
	"./components/FloatingWhatsAppButton/locales/en.json": "4c99",
	"./components/FloatingWhatsAppButton/locales/es.json": "0748",
	"./components/FloatingWhatsAppButton/locales/pt.json": "624f",
	"./components/Footer/locales/en.json": "27c7",
	"./components/Footer/locales/es.json": "f5c9",
	"./components/Footer/locales/pt.json": "4888",
	"./components/GoBack/locales/en.json": "178e",
	"./components/GoBack/locales/es.json": "153d",
	"./components/GoBack/locales/pt.json": "e84d",
	"./components/Graphics/locales/en.json": "9486",
	"./components/Graphics/locales/es.json": "0f55",
	"./components/Graphics/locales/pt.json": "76db",
	"./components/Input/Select/locales/en.json": "df8e",
	"./components/Input/Select/locales/es.json": "5601",
	"./components/Input/Select/locales/pt.json": "f353",
	"./components/Instruction/locales/en.json": "0af4",
	"./components/Instruction/locales/es.json": "a9c1",
	"./components/Instruction/locales/pt.json": "7e25",
	"./components/List/NotesTRI/components/Average/locales/en.json": "58aa",
	"./components/List/NotesTRI/components/Average/locales/es.json": "1329",
	"./components/List/NotesTRI/components/Average/locales/pt.json": "7cd4",
	"./components/List/NotesTRI/locales/en.json": "d509",
	"./components/List/NotesTRI/locales/es.json": "c683",
	"./components/List/NotesTRI/locales/pt.json": "be59",
	"./components/List/QuestionsListContainer/locales/en.json": "ff71",
	"./components/List/QuestionsListContainer/locales/es.json": "618e",
	"./components/List/QuestionsListContainer/locales/pt.json": "3ae7",
	"./components/List/QuestionsResultContainer/locales/en.json": "4e8b",
	"./components/List/QuestionsResultContainer/locales/es.json": "f718",
	"./components/List/QuestionsResultContainer/locales/pt.json": "165d",
	"./components/ListAllBooks/locales/en.json": "7ff1",
	"./components/ListAllBooks/locales/es.json": "a367",
	"./components/ListAllBooks/locales/pt.json": "6136",
	"./components/ListBooks/locales/en.json": "cb7a",
	"./components/ListBooks/locales/es.json": "2f56",
	"./components/ListBooks/locales/pt.json": "b990",
	"./components/Modal/ModalConcludeVideo/locales/en.json": "764d",
	"./components/Modal/ModalConcludeVideo/locales/es.json": "4f29",
	"./components/Modal/ModalConcludeVideo/locales/pt.json": "553c",
	"./components/Modal/ModalConsumerCredits/locales/en.json": "0d49",
	"./components/Modal/ModalConsumerCredits/locales/es.json": "31e7",
	"./components/Modal/ModalConsumerCredits/locales/pt.json": "d14e",
	"./components/Modal/ModalContentFree/locales/en.json": "3eb3",
	"./components/Modal/ModalContentFree/locales/es.json": "b69c",
	"./components/Modal/ModalContentFree/locales/pt.json": "2b9e",
	"./components/Modal/ModalCourse/locales/en.json": "93b5",
	"./components/Modal/ModalCourse/locales/es.json": "cea3",
	"./components/Modal/ModalCourse/locales/pt.json": "4304",
	"./components/Modal/ModalCredits/locales/en.json": "21d0",
	"./components/Modal/ModalCredits/locales/es.json": "4ced",
	"./components/Modal/ModalCredits/locales/pt.json": "84a1",
	"./components/Modal/ModalCreditsWarning/locales/en.json": "be71",
	"./components/Modal/ModalCreditsWarning/locales/es.json": "b4de",
	"./components/Modal/ModalCreditsWarning/locales/pt.json": "0c0f",
	"./components/Modal/ModalEndFeature/locales/en.json": "6cb1",
	"./components/Modal/ModalEndFeature/locales/es.json": "2ebd",
	"./components/Modal/ModalEndFeature/locales/pt.json": "8e67",
	"./components/Modal/ModalEndOfPlanTrial/locales/en.json": "ba30",
	"./components/Modal/ModalEndOfPlanTrial/locales/es.json": "68b3",
	"./components/Modal/ModalEndOfPlanTrial/locales/pt.json": "f656",
	"./components/Modal/ModalError/locales/en.json": "010a",
	"./components/Modal/ModalError/locales/es.json": "b712",
	"./components/Modal/ModalError/locales/pt.json": "216c",
	"./components/Modal/ModalExitSimulation/locales/en.json": "a556",
	"./components/Modal/ModalExitSimulation/locales/es.json": "8c1b",
	"./components/Modal/ModalExitSimulation/locales/pt.json": "ff4a",
	"./components/Modal/ModalNotContentPlan/locales/en.json": "d3c8",
	"./components/Modal/ModalNotContentPlan/locales/es.json": "0c81",
	"./components/Modal/ModalNotContentPlan/locales/pt.json": "77ff",
	"./components/Modal/ModalPlanUpdate/locales/en.json": "66dc",
	"./components/Modal/ModalPlanUpdate/locales/es.json": "3c47",
	"./components/Modal/ModalPlanUpdate/locales/pt.json": "d0b6",
	"./components/Modal/ModalPopUpPlanFree/locales/en.json": "4e4b",
	"./components/Modal/ModalPopUpPlanFree/locales/es.json": "1596",
	"./components/Modal/ModalPopUpPlanFree/locales/pt.json": "f14f",
	"./components/Modal/ModalRankingPass/locales/en.json": "3d04",
	"./components/Modal/ModalRankingPass/locales/es.json": "9fb5",
	"./components/Modal/ModalRankingPass/locales/pt.json": "2909",
	"./components/Modal/ModalSimulationResultLoading/locales/en.json": "f434",
	"./components/Modal/ModalSimulationResultLoading/locales/es.json": "0a36",
	"./components/Modal/ModalSimulationResultLoading/locales/pt.json": "70f9",
	"./components/Modal/ModalTimeFinish/locales/en.json": "f26a",
	"./components/Modal/ModalTimeFinish/locales/es.json": "bd14",
	"./components/Modal/ModalTimeFinish/locales/pt.json": "37c5",
	"./components/Modal/ModalTrialPlan/locales/en.json": "3d8f",
	"./components/Modal/ModalTrialPlan/locales/es.json": "0177",
	"./components/Modal/ModalTrialPlan/locales/pt.json": "d9c2",
	"./components/Modal/ModalVuetify/locales/en.json": "10a6",
	"./components/Modal/ModalVuetify/locales/es.json": "9b72",
	"./components/Modal/ModalVuetify/locales/pt.json": "983c",
	"./components/Modal/ModalWarning/locales/en.json": "e89a",
	"./components/Modal/ModalWarning/locales/es.json": "3d76",
	"./components/Modal/ModalWarning/locales/pt.json": "c785",
	"./components/Modal/ModalWelcome/locales/en.json": "4f94",
	"./components/Modal/ModalWelcome/locales/es.json": "17e4",
	"./components/Modal/ModalWelcome/locales/pt.json": "3aad",
	"./components/Modal/ModalWelcomeFeature/locales/en.json": "0248",
	"./components/Modal/ModalWelcomeFeature/locales/es.json": "0a25",
	"./components/Modal/ModalWelcomeFeature/locales/pt.json": "07b4",
	"./components/Modal/ModalWelcomePlanTrial/locales/en.json": "7ee7",
	"./components/Modal/ModalWelcomePlanTrial/locales/es.json": "7398",
	"./components/Modal/ModalWelcomePlanTrial/locales/pt.json": "9861",
	"./components/MyPerformanceRedaction/locales/en.json": "20ff",
	"./components/MyPerformanceRedaction/locales/es.json": "f970",
	"./components/MyPerformanceRedaction/locales/pt.json": "25a9",
	"./components/NavSidebar/locales/en.json": "fee9",
	"./components/NavSidebar/locales/es.json": "8ca5",
	"./components/NavSidebar/locales/pt.json": "99cc",
	"./components/OptionsContent/locales/en.json": "8b63",
	"./components/OptionsContent/locales/es.json": "dd16",
	"./components/OptionsContent/locales/pt.json": "decc",
	"./components/PageHeader/components/Credits/locales/en.json": "2334",
	"./components/PageHeader/components/Credits/locales/es.json": "7618",
	"./components/PageHeader/components/Credits/locales/pt.json": "7748",
	"./components/PageHeader/locales/en.json": "65ae",
	"./components/PageHeader/locales/es.json": "3581",
	"./components/PageHeader/locales/pt.json": "09bc",
	"./components/PdfViewer/locales/en.json": "53a1",
	"./components/PdfViewer/locales/es.json": "5bda",
	"./components/PdfViewer/locales/pt.json": "dd17",
	"./components/PerformanceCharts/locales/en.json": "0c35",
	"./components/PerformanceCharts/locales/es.json": "ec80",
	"./components/PerformanceCharts/locales/pt.json": "b4cb",
	"./components/ProgramationModules/locales/en.json": "61a0",
	"./components/ProgramationModules/locales/es.json": "f7ca",
	"./components/ProgramationModules/locales/pt.json": "0e0d",
	"./components/Question/AlternativeSummation/locales/en.json": "bca6",
	"./components/Question/AlternativeSummation/locales/es.json": "2611",
	"./components/Question/AlternativeSummation/locales/pt.json": "011b",
	"./components/Question/AlternativeSummationResult/locales/en.json": "60d0",
	"./components/Question/AlternativeSummationResult/locales/es.json": "d77b",
	"./components/Question/AlternativeSummationResult/locales/pt.json": "a286",
	"./components/Question/ResolutionRelateColumns/locales/en.json": "b055",
	"./components/Question/ResolutionRelateColumns/locales/es.json": "e4d5",
	"./components/Question/ResolutionRelateColumns/locales/pt.json": "3559",
	"./components/Question/ResolutionSummation/locales/en.json": "172c",
	"./components/Question/ResolutionSummation/locales/es.json": "d1b4",
	"./components/Question/ResolutionSummation/locales/pt.json": "178f",
	"./components/Question/ResolutionTruthyOrFalsy/locales/en.json": "6f44",
	"./components/Question/ResolutionTruthyOrFalsy/locales/es.json": "7d987",
	"./components/Question/ResolutionTruthyOrFalsy/locales/pt.json": "ead1",
	"./components/Question/SubjectiveQuestionInput/locales/en.json": "5c24",
	"./components/Question/SubjectiveQuestionInput/locales/es.json": "0b40",
	"./components/Question/SubjectiveQuestionInput/locales/pt.json": "f7aa",
	"./components/QuestionsUser/InputCalendar/locales/en.json": "ce21",
	"./components/QuestionsUser/InputCalendar/locales/es.json": "f549",
	"./components/QuestionsUser/InputCalendar/locales/pt.json": "b694",
	"./components/QuestionsUser/ScheduleTable/locales/en.json": "59647",
	"./components/QuestionsUser/ScheduleTable/locales/es.json": "e6d7",
	"./components/QuestionsUser/ScheduleTable/locales/pt.json": "02d2",
	"./components/Ranking/locales/en.json": "f8f5",
	"./components/Ranking/locales/es.json": "30d3",
	"./components/Ranking/locales/pt.json": "bc05",
	"./components/RankingMonth/Actions/locales/en.json": "30675",
	"./components/RankingMonth/Actions/locales/es.json": "1c2f",
	"./components/RankingMonth/Actions/locales/pt.json": "2f56e",
	"./components/RankingMonth/ModalSharePodium/locales/en.json": "8a1e",
	"./components/RankingMonth/ModalSharePodium/locales/es.json": "e854",
	"./components/RankingMonth/ModalSharePodium/locales/pt.json": "7877",
	"./components/RankingMonth/Podium/locales/en.json": "b2ca",
	"./components/RankingMonth/Podium/locales/es.json": "9ce3",
	"./components/RankingMonth/Podium/locales/pt.json": "8224",
	"./components/RankingMonth/UserPodium/locales/en.json": "04b7",
	"./components/RankingMonth/UserPodium/locales/es.json": "dbc9",
	"./components/RankingMonth/UserPodium/locales/pt.json": "ddc4",
	"./components/RankingMonth/locales/en.json": "11f7",
	"./components/RankingMonth/locales/es.json": "49b7",
	"./components/RankingMonth/locales/pt.json": "be10",
	"./components/Redaction/ContainerInstructionProposal/locales/en.json": "5ab3",
	"./components/Redaction/ContainerInstructionProposal/locales/es.json": "7046",
	"./components/Redaction/ContainerInstructionProposal/locales/pt.json": "cc2b",
	"./components/Redaction/ContainerSendRedaction/components/ImageRedaction/locales/en.json": "af50",
	"./components/Redaction/ContainerSendRedaction/components/ImageRedaction/locales/es.json": "e87e",
	"./components/Redaction/ContainerSendRedaction/components/ImageRedaction/locales/pt.json": "9ef4",
	"./components/Redaction/ContainerSendRedaction/components/RedactionDigited/locales/en.json": "01eb",
	"./components/Redaction/ContainerSendRedaction/components/RedactionDigited/locales/es.json": "59ca",
	"./components/Redaction/ContainerSendRedaction/components/RedactionDigited/locales/pt.json": "1eb7",
	"./components/Redaction/ContainerSendRedaction/locales/en.json": "e8f0",
	"./components/Redaction/ContainerSendRedaction/locales/es.json": "ae53",
	"./components/Redaction/ContainerSendRedaction/locales/pt.json": "a925d",
	"./components/Redaction/Modals/ModalConfigSendRedaction/locales/en.json": "facb",
	"./components/Redaction/Modals/ModalConfigSendRedaction/locales/es.json": "a5ce",
	"./components/Redaction/Modals/ModalConfigSendRedaction/locales/pt.json": "4ea6",
	"./components/Redaction/Modals/ModalOptionSendRedaction/locales/en.json": "a686",
	"./components/Redaction/Modals/ModalOptionSendRedaction/locales/es.json": "c34e",
	"./components/Redaction/Modals/ModalOptionSendRedaction/locales/pt.json": "da43",
	"./components/Redaction/Modals/locales/en.json": "0711",
	"./components/Redaction/Modals/locales/es.json": "d7e0",
	"./components/Redaction/Modals/locales/pt.json": "2133",
	"./components/Redaction/PrintRedactionSheet/locales/en.json": "d910",
	"./components/Redaction/PrintRedactionSheet/locales/es.json": "d2e3",
	"./components/Redaction/PrintRedactionSheet/locales/pt.json": "88c4",
	"./components/RedactionCorrection/components/Header/locales/en.json": "1145",
	"./components/RedactionCorrection/components/Header/locales/es.json": "6dff",
	"./components/RedactionCorrection/components/Header/locales/pt.json": "daaf",
	"./components/RedactionCorrection/components/Observation/locales/en.json": "901c",
	"./components/RedactionCorrection/components/Observation/locales/es.json": "7009",
	"./components/RedactionCorrection/components/Observation/locales/pt.json": "2aa5",
	"./components/RedactionCorrection/components/Performance/locales/en.json": "e6b4",
	"./components/RedactionCorrection/components/Performance/locales/es.json": "133b",
	"./components/RedactionCorrection/components/Performance/locales/pt.json": "7a2e",
	"./components/RedactionCorrection/components/Redaction/locales/en.json": "e705",
	"./components/RedactionCorrection/components/Redaction/locales/es.json": "a3bf",
	"./components/RedactionCorrection/components/Redaction/locales/pt.json": "e33f",
	"./components/RedactionCorrection/constants/locales/en.json": "0cb2",
	"./components/RedactionCorrection/constants/locales/es.json": "99a9",
	"./components/RedactionCorrection/constants/locales/pt.json": "68a2",
	"./components/Share/ListButtonsShare/locales/en.json": "24d5",
	"./components/Share/ListButtonsShare/locales/es.json": "3f2a",
	"./components/Share/ListButtonsShare/locales/pt.json": "dbb3",
	"./components/Share/locales/en.json": "ff2e",
	"./components/Share/locales/es.json": "2c8b",
	"./components/Share/locales/pt.json": "f45e",
	"./components/SidebarAccordion/SubjectOptionsSidebar/locales/en.json": "212b",
	"./components/SidebarAccordion/SubjectOptionsSidebar/locales/es.json": "3879",
	"./components/SidebarAccordion/SubjectOptionsSidebar/locales/pt.json": "e1e7",
	"./components/SplashScreen/locales/en.json": "a653",
	"./components/SplashScreen/locales/es.json": "ff77a",
	"./components/SplashScreen/locales/pt.json": "01c6",
	"./components/StopwatchFree/locales/en.json": "b58a",
	"./components/StopwatchFree/locales/es.json": "7d6b",
	"./components/StopwatchFree/locales/pt.json": "1f80",
	"./components/Subject/SubjectList/locales/en.json": "cba0",
	"./components/Subject/SubjectList/locales/es.json": "7311",
	"./components/Subject/SubjectList/locales/pt.json": "0d4f",
	"./components/Subject/SubjectQuestions/locales/en.json": "f811",
	"./components/Subject/SubjectQuestions/locales/es.json": "adbb",
	"./components/Subject/SubjectQuestions/locales/pt.json": "72a3",
	"./components/Subject/Tab/locales/en.json": "5db4",
	"./components/Subject/Tab/locales/es.json": "5479",
	"./components/Subject/Tab/locales/pt.json": "6976",
	"./components/SubjectTools/components/locales/en.json": "c7b0",
	"./components/SubjectTools/components/locales/es.json": "5dc5",
	"./components/SubjectTools/components/locales/pt.json": "6642",
	"./components/SubjectTools/locales/en.json": "4dad",
	"./components/SubjectTools/locales/es.json": "df07",
	"./components/SubjectTools/locales/pt.json": "43ad",
	"./components/TabsAccordion/ExerciseTab/locales/en.json": "c8b0",
	"./components/TabsAccordion/ExerciseTab/locales/es.json": "cbc7",
	"./components/TabsAccordion/ExerciseTab/locales/pt.json": "0f4f",
	"./components/TabsAccordion/InfoCountExercises/locales/en.json": "96a0",
	"./components/TabsAccordion/InfoCountExercises/locales/es.json": "fa35",
	"./components/TabsAccordion/InfoCountExercises/locales/pt.json": "cef4",
	"./components/TabsAccordion/MaterialDownload/locales/en.json": "624e",
	"./components/TabsAccordion/MaterialDownload/locales/es.json": "a2ed",
	"./components/TabsAccordion/MaterialDownload/locales/pt.json": "0258",
	"./components/TabsAccordion/MaterialList/locales/en.json": "6072",
	"./components/TabsAccordion/MaterialList/locales/es.json": "d654",
	"./components/TabsAccordion/MaterialList/locales/pt.json": "40ee",
	"./components/TabsAccordion/MaterialTab/locales/en.json": "a423",
	"./components/TabsAccordion/MaterialTab/locales/es.json": "6dd0",
	"./components/TabsAccordion/MaterialTab/locales/pt.json": "b814",
	"./components/TabsAccordion/VideosTab/locales/en.json": "426e",
	"./components/TabsAccordion/VideosTab/locales/es.json": "cf03",
	"./components/TabsAccordion/VideosTab/locales/pt.json": "851a",
	"./components/ThemeWeek/locales/en.json": "478a",
	"./components/ThemeWeek/locales/es.json": "6649",
	"./components/ThemeWeek/locales/pt.json": "ff55",
	"./components/Toastify/locales/en.json": "b6f1",
	"./components/Toastify/locales/es.json": "6a32",
	"./components/Toastify/locales/pt.json": "e8e4",
	"./components/ToggleModeSelector/locales/en.json": "83f4",
	"./components/ToggleModeSelector/locales/es.json": "cb83",
	"./components/ToggleModeSelector/locales/pt.json": "f6cb",
	"./components/ToggleSwitch/locales/en.json": "c70b",
	"./components/ToggleSwitch/locales/es.json": "db2e",
	"./components/ToggleSwitch/locales/pt.json": "fc94",
	"./components/Tooltip/locales/en.json": "4da0",
	"./components/Tooltip/locales/es.json": "5659",
	"./components/Tooltip/locales/pt.json": "3816",
	"./components/VideoThumb/locales/en.json": "68cc",
	"./components/VideoThumb/locales/es.json": "3f34",
	"./components/VideoThumb/locales/pt.json": "d3c8c",
	"./components/WrapperContent/locales/en.json": "f691",
	"./components/WrapperContent/locales/es.json": "9166",
	"./components/WrapperContent/locales/pt.json": "ec31",
	"./components/WrapperInstability/locales/en.json": "63fd",
	"./components/WrapperInstability/locales/es.json": "a4f9",
	"./components/WrapperInstability/locales/pt.json": "cd58",
	"./constant/locales/en.json": "f25f",
	"./constant/locales/es.json": "b611",
	"./constant/locales/pt.json": "e10b",
	"./locales/en.json": "edd4",
	"./locales/es.json": "a306",
	"./locales/pt.json": "5d67",
	"./mixins/locales/en.json": "88b5",
	"./mixins/locales/es.json": "7a89",
	"./mixins/locales/pt.json": "adfb",
	"./pages/Book/components/BookSidebar/components/ContentDetails/locales/en.json": "e426",
	"./pages/Book/components/BookSidebar/components/ContentDetails/locales/es.json": "159d",
	"./pages/Book/components/BookSidebar/components/ContentDetails/locales/pt.json": "a8b1",
	"./pages/Book/components/BookSidebar/components/ContentFilter/locales/en.json": "0ff2",
	"./pages/Book/components/BookSidebar/components/ContentFilter/locales/es.json": "c17b",
	"./pages/Book/components/BookSidebar/components/ContentFilter/locales/pt.json": "aa15",
	"./pages/Book/components/BookSidebar/locales/en.json": "97e4",
	"./pages/Book/components/BookSidebar/locales/es.json": "d858",
	"./pages/Book/components/BookSidebar/locales/pt.json": "6831",
	"./pages/Book/components/LastClassViewed/locales/en.json": "96e8",
	"./pages/Book/components/LastClassViewed/locales/es.json": "0a71",
	"./pages/Book/components/LastClassViewed/locales/pt.json": "6e71",
	"./pages/Book/components/TabSubject/locales/en.json": "84b3",
	"./pages/Book/components/TabSubject/locales/es.json": "03f4",
	"./pages/Book/components/TabSubject/locales/pt.json": "cf57",
	"./pages/Book/locales/en.json": "3e3f",
	"./pages/Book/locales/es.json": "80e0",
	"./pages/Book/locales/pt.json": "d517",
	"./pages/Books/components/BookTabs/locales/en.json": "e519",
	"./pages/Books/components/BookTabs/locales/es.json": "12f8",
	"./pages/Books/components/BookTabs/locales/pt.json": "a036",
	"./pages/Books/locales/en.json": "b8a5",
	"./pages/Books/locales/es.json": "2966",
	"./pages/Books/locales/pt.json": "8649",
	"./pages/Books/pages/TutorialBooks/locales/en.json": "050b",
	"./pages/Books/pages/TutorialBooks/locales/es.json": "ded2",
	"./pages/Books/pages/TutorialBooks/locales/pt.json": "c84a",
	"./pages/Calendar/locales/en.json": "348b",
	"./pages/Calendar/locales/es.json": "bfb9",
	"./pages/Calendar/locales/pt.json": "fcdd",
	"./pages/Calendar/pages/TutorialCalendar/locales/en.json": "9ad4",
	"./pages/Calendar/pages/TutorialCalendar/locales/es.json": "9da3",
	"./pages/Calendar/pages/TutorialCalendar/locales/pt.json": "8f2e",
	"./pages/Classes/components/ActivityCards/locales/en.json": "cc4d",
	"./pages/Classes/components/ActivityCards/locales/es.json": "9728",
	"./pages/Classes/components/ActivityCards/locales/pt.json": "eae8",
	"./pages/Classes/components/ActivityFilter/locales/en.json": "6a8c",
	"./pages/Classes/components/ActivityFilter/locales/es.json": "1b1d",
	"./pages/Classes/components/ActivityFilter/locales/pt.json": "afb1",
	"./pages/Classes/components/CardClass/locales/en.json": "e093",
	"./pages/Classes/components/CardClass/locales/es.json": "6e0a",
	"./pages/Classes/components/CardClass/locales/pt.json": "50a0",
	"./pages/Classes/components/CardClassroom/locales/en.json": "637c",
	"./pages/Classes/components/CardClassroom/locales/es.json": "4e16",
	"./pages/Classes/components/CardClassroom/locales/pt.json": "25b4",
	"./pages/Classes/locales/en.json": "7c34",
	"./pages/Classes/locales/es.json": "1686",
	"./pages/Classes/locales/pt.json": "e31d",
	"./pages/Classes/pages/Activities/components/ActivityCommentsModal/locales/en.json": "95a9",
	"./pages/Classes/pages/Activities/components/ActivityCommentsModal/locales/es.json": "cad3",
	"./pages/Classes/pages/Activities/components/ActivityCommentsModal/locales/pt.json": "95b2",
	"./pages/Classes/pages/Activities/components/ActivityModal/locales/en.json": "f9de",
	"./pages/Classes/pages/Activities/components/ActivityModal/locales/es.json": "7161",
	"./pages/Classes/pages/Activities/components/ActivityModal/locales/pt.json": "151e",
	"./pages/Classes/pages/Activities/components/ActivityTestModal/locales/en.json": "13d55",
	"./pages/Classes/pages/Activities/components/ActivityTestModal/locales/es.json": "89b9",
	"./pages/Classes/pages/Activities/components/ActivityTestModal/locales/pt.json": "3b2d",
	"./pages/Classes/pages/Activities/components/DeliveryTracking/locales/en.json": "ab6d",
	"./pages/Classes/pages/Activities/components/DeliveryTracking/locales/es.json": "6c8e",
	"./pages/Classes/pages/Activities/components/DeliveryTracking/locales/pt.json": "fd24",
	"./pages/Classes/pages/Activities/components/ModalProfessorChat/locales/en.json": "8720",
	"./pages/Classes/pages/Activities/components/ModalProfessorChat/locales/es.json": "a2d8",
	"./pages/Classes/pages/Activities/components/ModalProfessorChat/locales/pt.json": "2df9",
	"./pages/Classes/pages/Activities/components/MyDeliveries/locales/en.json": "812e",
	"./pages/Classes/pages/Activities/components/MyDeliveries/locales/es.json": "b6c6",
	"./pages/Classes/pages/Activities/components/MyDeliveries/locales/pt.json": "743b",
	"./pages/Classes/pages/Activities/components/ReferenceMaterial/locales/en.json": "d3d0",
	"./pages/Classes/pages/Activities/components/ReferenceMaterial/locales/es.json": "6814",
	"./pages/Classes/pages/Activities/components/ReferenceMaterial/locales/pt.json": "c053",
	"./pages/Classes/pages/Activities/components/TaskUpload/locales/en.json": "9e2a",
	"./pages/Classes/pages/Activities/components/TaskUpload/locales/es.json": "969c",
	"./pages/Classes/pages/Activities/components/TaskUpload/locales/pt.json": "58ce",
	"./pages/Classes/pages/Activities/components/locales/en.json": "e6d0",
	"./pages/Classes/pages/Activities/components/locales/es.json": "540d",
	"./pages/Classes/pages/Activities/components/locales/pt.json": "0ee3",
	"./pages/Classes/pages/Activities/locales/en.json": "fccf",
	"./pages/Classes/pages/Activities/locales/es.json": "5fe9",
	"./pages/Classes/pages/Activities/locales/pt.json": "3c55",
	"./pages/Classes/pages/ClassRoom/locales/en.json": "b4cb2",
	"./pages/Classes/pages/ClassRoom/locales/es.json": "34f9",
	"./pages/Classes/pages/ClassRoom/locales/pt.json": "33d2",
	"./pages/Classes/pages/Course/locales/en.json": "39e6",
	"./pages/Classes/pages/Course/locales/es.json": "a827",
	"./pages/Classes/pages/Course/locales/pt.json": "fff0",
	"./pages/Classes/pages/Notes/locales/en.json": "380d",
	"./pages/Classes/pages/Notes/locales/es.json": "4bd1",
	"./pages/Classes/pages/Notes/locales/pt.json": "c654",
	"./pages/Classes/pages/TutorialClasses/locales/en.json": "e768",
	"./pages/Classes/pages/TutorialClasses/locales/es.json": "8216",
	"./pages/Classes/pages/TutorialClasses/locales/pt.json": "100c",
	"./pages/Classes/pages/Wall/components/CreateComment/locales/en.json": "3ab3",
	"./pages/Classes/pages/Wall/components/CreateComment/locales/es.json": "638c",
	"./pages/Classes/pages/Wall/components/CreateComment/locales/pt.json": "290e",
	"./pages/Classes/pages/Wall/components/CreatePost/locales/en.json": "3023",
	"./pages/Classes/pages/Wall/components/CreatePost/locales/es.json": "3bac",
	"./pages/Classes/pages/Wall/components/CreatePost/locales/pt.json": "209f",
	"./pages/Classes/pages/Wall/components/PostComments/locales/en.json": "1dad",
	"./pages/Classes/pages/Wall/components/PostComments/locales/es.json": "6d5e",
	"./pages/Classes/pages/Wall/components/PostComments/locales/pt.json": "023a",
	"./pages/Courses/components/CourseAccordion/locales/en.json": "8259",
	"./pages/Courses/components/CourseAccordion/locales/es.json": "bdcd",
	"./pages/Courses/components/CourseAccordion/locales/pt.json": "2327",
	"./pages/Courses/components/CourseModal/locales/en.json": "8cab",
	"./pages/Courses/components/CourseModal/locales/es.json": "50f5",
	"./pages/Courses/components/CourseModal/locales/pt.json": "957b",
	"./pages/Courses/components/CourseSidebar/locales/en.json": "4175",
	"./pages/Courses/components/CourseSidebar/locales/es.json": "f6ad",
	"./pages/Courses/components/CourseSidebar/locales/pt.json": "fe2a",
	"./pages/Courses/components/TabAccordion/locales/en.json": "645f",
	"./pages/Courses/components/TabAccordion/locales/es.json": "b750",
	"./pages/Courses/components/TabAccordion/locales/pt.json": "478f",
	"./pages/Courses/locales/en.json": "eb2d",
	"./pages/Courses/locales/es.json": "ab2d8",
	"./pages/Courses/locales/pt.json": "c476",
	"./pages/Courses/pages/CourseConfig/locales/en.json": "25e3",
	"./pages/Courses/pages/CourseConfig/locales/es.json": "0eb9",
	"./pages/Courses/pages/CourseConfig/locales/pt.json": "eb6b",
	"./pages/Courses/pages/CourseProgramation/locales/en.json": "686b",
	"./pages/Courses/pages/CourseProgramation/locales/es.json": "30a8",
	"./pages/Courses/pages/CourseProgramation/locales/pt.json": "aed3",
	"./pages/Courses/pages/ListCourses/locales/en.json": "b671",
	"./pages/Courses/pages/ListCourses/locales/es.json": "13bb",
	"./pages/Courses/pages/ListCourses/locales/pt.json": "4fbe",
	"./pages/Courses/pages/TutorialCourse/locales/en.json": "dfad",
	"./pages/Courses/pages/TutorialCourse/locales/es.json": "8795",
	"./pages/Courses/pages/TutorialCourse/locales/pt.json": "14d4",
	"./pages/Dashboard/components/ContainerRedaction/locales/en.json": "2982",
	"./pages/Dashboard/components/ContainerRedaction/locales/es.json": "3397",
	"./pages/Dashboard/components/ContainerRedaction/locales/pt.json": "6fdc",
	"./pages/Dashboard/components/CourseDashboard/components/MyCourses/locales/en.json": "dbbd",
	"./pages/Dashboard/components/CourseDashboard/components/MyCourses/locales/es.json": "6d27",
	"./pages/Dashboard/components/CourseDashboard/components/MyCourses/locales/pt.json": "8d78",
	"./pages/Dashboard/components/CourseDashboard/locales/en.json": "afc1",
	"./pages/Dashboard/components/CourseDashboard/locales/es.json": "bd8b",
	"./pages/Dashboard/components/CourseDashboard/locales/pt.json": "c862",
	"./pages/Dashboard/components/CourseInProgress/locales/en.json": "9ff9",
	"./pages/Dashboard/components/CourseInProgress/locales/es.json": "b5cf",
	"./pages/Dashboard/components/CourseInProgress/locales/pt.json": "afed",
	"./pages/Dashboard/components/ListBooks/locales/en.json": "5aee",
	"./pages/Dashboard/components/ListBooks/locales/es.json": "d356",
	"./pages/Dashboard/components/ListBooks/locales/pt.json": "3380",
	"./pages/Dashboard/components/MainDashboard/locales/en.json": "77e6",
	"./pages/Dashboard/components/MainDashboard/locales/es.json": "a216",
	"./pages/Dashboard/components/MainDashboard/locales/pt.json": "b85c",
	"./pages/Dashboard/components/RedactionDashboard/locales/en.json": "43f5",
	"./pages/Dashboard/components/RedactionDashboard/locales/es.json": "c34c",
	"./pages/Dashboard/components/RedactionDashboard/locales/pt.json": "476c",
	"./pages/Dashboard/locales/en.json": "57b1",
	"./pages/Dashboard/locales/es.json": "98b1",
	"./pages/Dashboard/locales/pt.json": "ed4f",
	"./pages/Doubts/components/LastSendDoubt/locales/en.json": "6d70",
	"./pages/Doubts/components/LastSendDoubt/locales/es.json": "9233",
	"./pages/Doubts/components/LastSendDoubt/locales/pt.json": "ebf5",
	"./pages/Doubts/locales/en.json": "d3de",
	"./pages/Doubts/locales/es.json": "4909",
	"./pages/Doubts/locales/pt.json": "ad48",
	"./pages/Doubts/pages/NewDoubt/locales/en.json": "1f88",
	"./pages/Doubts/pages/NewDoubt/locales/es.json": "e058",
	"./pages/Doubts/pages/NewDoubt/locales/pt.json": "d65a",
	"./pages/Doubts/pages/ShowDoubts/components/Actions/locales/en.json": "6feb",
	"./pages/Doubts/pages/ShowDoubts/components/Actions/locales/es.json": "de4c",
	"./pages/Doubts/pages/ShowDoubts/components/Actions/locales/pt.json": "35eb",
	"./pages/Doubts/pages/ShowDoubts/components/ReplyContent/locales/en.json": "85d0",
	"./pages/Doubts/pages/ShowDoubts/components/ReplyContent/locales/es.json": "00cd",
	"./pages/Doubts/pages/ShowDoubts/components/ReplyContent/locales/pt.json": "ef99",
	"./pages/Doubts/pages/ShowDoubts/components/ReplyDoubt/locales/en.json": "eb48",
	"./pages/Doubts/pages/ShowDoubts/components/ReplyDoubt/locales/es.json": "bbb7",
	"./pages/Doubts/pages/ShowDoubts/components/ReplyDoubt/locales/pt.json": "32a3",
	"./pages/Doubts/pages/ShowDoubts/components/ReplyHeader/locales/en.json": "e59b",
	"./pages/Doubts/pages/ShowDoubts/components/ReplyHeader/locales/es.json": "a39b",
	"./pages/Doubts/pages/ShowDoubts/components/ReplyHeader/locales/pt.json": "73a1",
	"./pages/Doubts/pages/ShowDoubts/locales/en.json": "5edb",
	"./pages/Doubts/pages/ShowDoubts/locales/es.json": "a959b",
	"./pages/Doubts/pages/ShowDoubts/locales/pt.json": "d9a5",
	"./pages/Doubts/pages/TutorialDoubts/locales/en.json": "3c3f",
	"./pages/Doubts/pages/TutorialDoubts/locales/es.json": "9be8",
	"./pages/Doubts/pages/TutorialDoubts/locales/pt.json": "2fdd",
	"./pages/Exams/components/AccordionExam/locales/en.json": "a4c1",
	"./pages/Exams/components/AccordionExam/locales/es.json": "306d",
	"./pages/Exams/components/AccordionExam/locales/pt.json": "d32d",
	"./pages/Exams/components/ListFiles/locales/en.json": "967c",
	"./pages/Exams/components/ListFiles/locales/es.json": "da85",
	"./pages/Exams/components/ListFiles/locales/pt.json": "1c4f",
	"./pages/Exams/locales/en.json": "3c21",
	"./pages/Exams/locales/es.json": "43e8",
	"./pages/Exams/locales/pt.json": "2317",
	"./pages/Exams/pages/Exam/locales/en.json": "2f98",
	"./pages/Exams/pages/Exam/locales/es.json": "3afe",
	"./pages/Exams/pages/Exam/locales/pt.json": "1c44",
	"./pages/Exams/pages/ExamViewer/components/ExamsAccordionViewer/locales/en.json": "d8b6",
	"./pages/Exams/pages/ExamViewer/components/ExamsAccordionViewer/locales/es.json": "d3a3",
	"./pages/Exams/pages/ExamViewer/components/ExamsAccordionViewer/locales/pt.json": "0112",
	"./pages/Exams/pages/ExamViewer/locales/en.json": "9639",
	"./pages/Exams/pages/ExamViewer/locales/es.json": "0d12",
	"./pages/Exams/pages/ExamViewer/locales/pt.json": "10d9",
	"./pages/Exams/pages/TutorialExam/locales/en.json": "a685",
	"./pages/Exams/pages/TutorialExam/locales/es.json": "e0a8",
	"./pages/Exams/pages/TutorialExam/locales/pt.json": "0564",
	"./pages/Exercise/components/ExerciseInstruction/locales/en.json": "2ef9",
	"./pages/Exercise/components/ExerciseInstruction/locales/es.json": "1605",
	"./pages/Exercise/components/ExerciseInstruction/locales/pt.json": "2149",
	"./pages/Exercise/components/ExercisePersonalize/locales/en.json": "749b",
	"./pages/Exercise/components/ExercisePersonalize/locales/es.json": "1410",
	"./pages/Exercise/components/ExercisePersonalize/locales/pt.json": "f9c6",
	"./pages/Exercise/components/ModalInstrucoes/locales/en.json": "d854",
	"./pages/Exercise/components/ModalInstrucoes/locales/es.json": "c6ad",
	"./pages/Exercise/components/ModalInstrucoes/locales/pt.json": "aee1",
	"./pages/Exercise/locales/en.json": "be68",
	"./pages/Exercise/locales/es.json": "286e",
	"./pages/Exercise/locales/pt.json": "d631",
	"./pages/Exercise/pages/ExerciseQuestions/locales/en.json": "815b",
	"./pages/Exercise/pages/ExerciseQuestions/locales/es.json": "6327",
	"./pages/Exercise/pages/ExerciseQuestions/locales/pt.json": "0226",
	"./pages/Exercise/pages/ExerciseResult/components/Graphics/locales/en.json": "04ee",
	"./pages/Exercise/pages/ExerciseResult/components/Graphics/locales/es.json": "0561",
	"./pages/Exercise/pages/ExerciseResult/components/Graphics/locales/pt.json": "669a",
	"./pages/Exercise/pages/ExerciseResult/components/ModalExerciseCompletedScore/locales/en.json": "e611",
	"./pages/Exercise/pages/ExerciseResult/components/ModalExerciseCompletedScore/locales/es.json": "c1e7",
	"./pages/Exercise/pages/ExerciseResult/components/ModalExerciseCompletedScore/locales/pt.json": "6576",
	"./pages/Exercise/pages/ExerciseResult/locales/en.json": "fa52",
	"./pages/Exercise/pages/ExerciseResult/locales/es.json": "5701",
	"./pages/Exercise/pages/ExerciseResult/locales/pt.json": "dcc5",
	"./pages/Exercise/pages/ExerciseResultPerformance/components/SubjectPerfomance/locales/en.json": "2ac2",
	"./pages/Exercise/pages/ExerciseResultPerformance/components/SubjectPerfomance/locales/es.json": "8726",
	"./pages/Exercise/pages/ExerciseResultPerformance/components/SubjectPerfomance/locales/pt.json": "660f",
	"./pages/Exercise/pages/ExerciseResultPerformance/locales/en.json": "ed12",
	"./pages/Exercise/pages/ExerciseResultPerformance/locales/es.json": "ef03",
	"./pages/Exercise/pages/ExerciseResultPerformance/locales/pt.json": "c7b8",
	"./pages/Exercise/pages/TutorialExercise/locales/en.json": "5343",
	"./pages/Exercise/pages/TutorialExercise/locales/es.json": "4b7f",
	"./pages/Exercise/pages/TutorialExercise/locales/pt.json": "debe",
	"./pages/Feedback/locales/en.json": "6970",
	"./pages/Feedback/locales/es.json": "0560",
	"./pages/Feedback/locales/pt.json": "5884",
	"./pages/Grades/components/DataTable/locales/en.json": "4022",
	"./pages/Grades/components/DataTable/locales/es.json": "40d0",
	"./pages/Grades/components/DataTable/locales/pt.json": "a52e",
	"./pages/Grades/components/Filters/locales/en.json": "a2aa",
	"./pages/Grades/components/Filters/locales/es.json": "845b",
	"./pages/Grades/components/Filters/locales/pt.json": "cc51",
	"./pages/Grades/locales/en.json": "18f6",
	"./pages/Grades/locales/es.json": "bfa3",
	"./pages/Grades/locales/pt.json": "62b2",
	"./pages/Help/locales/en.json": "c148",
	"./pages/Help/locales/es.json": "0acb",
	"./pages/Help/locales/pt.json": "3664",
	"./pages/Help/pages/Faq/constants/locales/en.json": "dacc",
	"./pages/Help/pages/Faq/constants/locales/es.json": "2998",
	"./pages/Help/pages/Faq/constants/locales/pt.json": "7e21",
	"./pages/Help/pages/Tools/locales/en.json": "ab35",
	"./pages/Help/pages/Tools/locales/es.json": "e352",
	"./pages/Help/pages/Tools/locales/pt.json": "26c0",
	"./pages/HistoricPayment/components/HistoricTable/locales/en.json": "a129",
	"./pages/HistoricPayment/components/HistoricTable/locales/es.json": "1561",
	"./pages/HistoricPayment/components/HistoricTable/locales/pt.json": "ad78",
	"./pages/HistoricPayment/components/ModalHistoric/locales/en.json": "a483",
	"./pages/HistoricPayment/components/ModalHistoric/locales/es.json": "3c7e",
	"./pages/HistoricPayment/components/ModalHistoric/locales/pt.json": "aa75",
	"./pages/HistoricPayment/locales/en.json": "1f90",
	"./pages/HistoricPayment/locales/es.json": "50ac",
	"./pages/HistoricPayment/locales/pt.json": "1fb6",
	"./pages/Instability/locales/en.json": "4740",
	"./pages/Instability/locales/es.json": "26d1",
	"./pages/Instability/locales/pt.json": "0311",
	"./pages/Maintenance/locales/en.json": "ceac",
	"./pages/Maintenance/locales/es.json": "e94a",
	"./pages/Maintenance/locales/pt.json": "041b",
	"./pages/Materials/components/MaterialsAccordion/locales/en.json": "ba86",
	"./pages/Materials/components/MaterialsAccordion/locales/es.json": "f373",
	"./pages/Materials/components/MaterialsAccordion/locales/pt.json": "8d8d",
	"./pages/Materials/components/MaterialsHeaderAccordion/locales/en.json": "007a",
	"./pages/Materials/components/MaterialsHeaderAccordion/locales/es.json": "2eed",
	"./pages/Materials/components/MaterialsHeaderAccordion/locales/pt.json": "48fa",
	"./pages/Materials/locales/en.json": "88d7",
	"./pages/Materials/locales/es.json": "1f7b",
	"./pages/Materials/locales/pt.json": "d086",
	"./pages/Messages/components/ChatMessages/locales/en.json": "2528",
	"./pages/Messages/components/ChatMessages/locales/es.json": "4385",
	"./pages/Messages/components/ChatMessages/locales/pt.json": "fcdb",
	"./pages/Messages/locales/en.json": "27b6",
	"./pages/Messages/locales/es.json": "95c2",
	"./pages/Messages/locales/pt.json": "0821",
	"./pages/NotFound/locales/en.json": "1ed3",
	"./pages/NotFound/locales/es.json": "7c3d",
	"./pages/NotFound/locales/pt.json": "b620",
	"./pages/Planner/components/FeedbackPermissionPlanner/locales/en.json": "fd81",
	"./pages/Planner/components/FeedbackPermissionPlanner/locales/es.json": "53f9",
	"./pages/Planner/components/FeedbackPermissionPlanner/locales/pt.json": "4082",
	"./pages/Planner/components/PlannerSidebar/locales/en.json": "c0b6",
	"./pages/Planner/components/PlannerSidebar/locales/es.json": "b70d",
	"./pages/Planner/components/PlannerSidebar/locales/pt.json": "3a59",
	"./pages/Planner/components/SummaryPlanner/locales/en.json": "10fc",
	"./pages/Planner/components/SummaryPlanner/locales/es.json": "4cc3",
	"./pages/Planner/components/SummaryPlanner/locales/pt.json": "06ba",
	"./pages/Planner/components/TimeCalendarPlanner/locales/en.json": "9838",
	"./pages/Planner/components/TimeCalendarPlanner/locales/es.json": "983a",
	"./pages/Planner/components/TimeCalendarPlanner/locales/pt.json": "4c7a",
	"./pages/Planner/components/locales/en.json": "d9c5",
	"./pages/Planner/components/locales/es.json": "8ac5",
	"./pages/Planner/components/locales/pt.json": "f1b9",
	"./pages/Planner/locales/en.json": "f9b1",
	"./pages/Planner/locales/es.json": "ad81",
	"./pages/Planner/locales/pt.json": "12cc1",
	"./pages/Planner/pages/PlannerConfig/components/FeedbackQuestion/locales/en.json": "20c8",
	"./pages/Planner/pages/PlannerConfig/components/FeedbackQuestion/locales/es.json": "f7e3",
	"./pages/Planner/pages/PlannerConfig/components/FeedbackQuestion/locales/pt.json": "1d9b",
	"./pages/Planner/pages/PlannerConfig/components/InstructionUser/locales/en.json": "d877",
	"./pages/Planner/pages/PlannerConfig/components/InstructionUser/locales/es.json": "d581",
	"./pages/Planner/pages/PlannerConfig/components/InstructionUser/locales/pt.json": "a399",
	"./pages/Planner/pages/PlannerConfig/components/ModalError/locales/en.json": "60cd",
	"./pages/Planner/pages/PlannerConfig/components/ModalError/locales/es.json": "11ba",
	"./pages/Planner/pages/PlannerConfig/components/ModalError/locales/pt.json": "f092",
	"./pages/Planner/pages/PlannerConfig/components/ModalHistoric/locales/en.json": "f481",
	"./pages/Planner/pages/PlannerConfig/components/ModalHistoric/locales/es.json": "78e0",
	"./pages/Planner/pages/PlannerConfig/components/ModalHistoric/locales/pt.json": "6aa1",
	"./pages/Planner/pages/PlannerConfig/components/WrapperQuestion/locales/en.json": "2d42",
	"./pages/Planner/pages/PlannerConfig/components/WrapperQuestion/locales/es.json": "ef30",
	"./pages/Planner/pages/PlannerConfig/components/WrapperQuestion/locales/pt.json": "f4ab",
	"./pages/Planner/pages/PlannerConfig/locales/en.json": "3dc5",
	"./pages/Planner/pages/PlannerConfig/locales/es.json": "b39f",
	"./pages/Planner/pages/PlannerConfig/locales/pt.json": "209c",
	"./pages/Planner/pages/TutorialPlanner/locales/en.json": "adf7",
	"./pages/Planner/pages/TutorialPlanner/locales/es.json": "84c1",
	"./pages/Planner/pages/TutorialPlanner/locales/pt.json": "e2b6",
	"./pages/Problem/locales/en.json": "68b2",
	"./pages/Problem/locales/es.json": "5dd3",
	"./pages/Problem/locales/pt.json": "9f98",
	"./pages/Profile/components/Achievements/locales/en.json": "ceed",
	"./pages/Profile/components/Achievements/locales/es.json": "e62f",
	"./pages/Profile/components/Achievements/locales/pt.json": "842e",
	"./pages/Profile/components/ChangePassword/components/ModalPassword/locales/en.json": "af96",
	"./pages/Profile/components/ChangePassword/components/ModalPassword/locales/es.json": "e74b",
	"./pages/Profile/components/ChangePassword/components/ModalPassword/locales/pt.json": "eb1f",
	"./pages/Profile/components/ChangePassword/locales/en.json": "aac8",
	"./pages/Profile/components/ChangePassword/locales/es.json": "e5a2",
	"./pages/Profile/components/ChangePassword/locales/pt.json": "de592",
	"./pages/Profile/components/MyClass/components/ListUsers/locales/en.json": "2a49",
	"./pages/Profile/components/MyClass/components/ListUsers/locales/es.json": "6117",
	"./pages/Profile/components/MyClass/components/ListUsers/locales/pt.json": "fd16",
	"./pages/Profile/components/MyClass/locales/en.json": "ee77",
	"./pages/Profile/components/MyClass/locales/es.json": "f644",
	"./pages/Profile/components/MyClass/locales/pt.json": "95fd",
	"./pages/Profile/components/MyData/components/ConsentTerms/locales/en.json": "78e5",
	"./pages/Profile/components/MyData/components/ConsentTerms/locales/es.json": "5a7c",
	"./pages/Profile/components/MyData/components/ConsentTerms/locales/pt.json": "688f",
	"./pages/Profile/components/MyData/components/ModalMyData/locales/en.json": "373f",
	"./pages/Profile/components/MyData/components/ModalMyData/locales/es.json": "c450",
	"./pages/Profile/components/MyData/components/ModalMyData/locales/pt.json": "d2ca",
	"./pages/Profile/components/MyData/components/PersonalData/locales/en.json": "2703",
	"./pages/Profile/components/MyData/components/PersonalData/locales/es.json": "a63e",
	"./pages/Profile/components/MyData/components/PersonalData/locales/pt.json": "f966",
	"./pages/Profile/components/MyData/components/PhotoProfile/locales/en.json": "06c6",
	"./pages/Profile/components/MyData/components/PhotoProfile/locales/es.json": "f828",
	"./pages/Profile/components/MyData/components/PhotoProfile/locales/pt.json": "136e",
	"./pages/Profile/components/MyData/locales/en.json": "d9d6",
	"./pages/Profile/components/MyData/locales/es.json": "3c28",
	"./pages/Profile/components/MyData/locales/pt.json": "0e10",
	"./pages/Profile/components/MyPerformance/components/TableHistoricAccess/locales/en.json": "60ce",
	"./pages/Profile/components/MyPerformance/components/TableHistoricAccess/locales/es.json": "cda6",
	"./pages/Profile/components/MyPerformance/components/TableHistoricAccess/locales/pt.json": "ee0e",
	"./pages/Profile/components/MyPerformance/locales/en.json": "e574",
	"./pages/Profile/components/MyPerformance/locales/es.json": "6ef2",
	"./pages/Profile/components/MyPerformance/locales/pt.json": "830f",
	"./pages/Profile/components/Notification/components/ContentNotifications/locales/en.json": "7532",
	"./pages/Profile/components/Notification/components/ContentNotifications/locales/es.json": "b49b",
	"./pages/Profile/components/Notification/components/ContentNotifications/locales/pt.json": "1ad1",
	"./pages/Profile/components/Notification/locales/en.json": "0ca8",
	"./pages/Profile/components/Notification/locales/es.json": "77f9",
	"./pages/Profile/components/Notification/locales/pt.json": "5156",
	"./pages/Profile/components/Plan/locales/en.json": "2c2f",
	"./pages/Profile/components/Plan/locales/es.json": "ca37",
	"./pages/Profile/components/Plan/locales/pt.json": "fe08",
	"./pages/Profile/locales/en.json": "d0f0",
	"./pages/Profile/locales/es.json": "4783",
	"./pages/Profile/locales/pt.json": "1ef9",
	"./pages/Question/components/LastQuestionViewed/locales/en.json": "2563",
	"./pages/Question/components/LastQuestionViewed/locales/es.json": "7ed4",
	"./pages/Question/components/LastQuestionViewed/locales/pt.json": "b317",
	"./pages/Question/components/QuestionItem/locales/en.json": "bf8b",
	"./pages/Question/components/QuestionItem/locales/es.json": "b8ea",
	"./pages/Question/components/QuestionItem/locales/pt.json": "ff40",
	"./pages/Question/components/RelatedQuestions/locales/en.json": "5ed5",
	"./pages/Question/components/RelatedQuestions/locales/es.json": "6331",
	"./pages/Question/components/RelatedQuestions/locales/pt.json": "a555",
	"./pages/Question/locales/en.json": "4e4b6",
	"./pages/Question/locales/es.json": "9605",
	"./pages/Question/locales/pt.json": "2f11",
	"./pages/Question/pages/AnswerQuestion/locales/en.json": "f7cf",
	"./pages/Question/pages/AnswerQuestion/locales/es.json": "d742",
	"./pages/Question/pages/AnswerQuestion/locales/pt.json": "9066",
	"./pages/Question/pages/TutorialQuestions/locales/en.json": "50e9",
	"./pages/Question/pages/TutorialQuestions/locales/es.json": "e226",
	"./pages/Question/pages/TutorialQuestions/locales/pt.json": "f78b",
	"./pages/Ranking/components/Instructions/locales/en.json": "c301",
	"./pages/Ranking/components/Instructions/locales/es.json": "ed1d",
	"./pages/Ranking/components/Instructions/locales/pt.json": "d207",
	"./pages/Ranking/components/Levels/locales/en.json": "248f",
	"./pages/Ranking/components/Levels/locales/es.json": "b799",
	"./pages/Ranking/components/Levels/locales/pt.json": "6cba",
	"./pages/Ranking/components/RankingUser/locales/en.json": "485a5",
	"./pages/Ranking/components/RankingUser/locales/es.json": "9870",
	"./pages/Ranking/components/RankingUser/locales/pt.json": "996c",
	"./pages/Ranking/components/RankingUsers/locales/en.json": "7c7c",
	"./pages/Ranking/components/RankingUsers/locales/es.json": "a885",
	"./pages/Ranking/components/RankingUsers/locales/pt.json": "c6c5",
	"./pages/Ranking/locales/en.json": "fc96",
	"./pages/Ranking/locales/es.json": "5a57",
	"./pages/Ranking/locales/pt.json": "87ab",
	"./pages/Redaction/components/AccordionRedaction/locales/en.json": "c8ca",
	"./pages/Redaction/components/AccordionRedaction/locales/es.json": "fb2f",
	"./pages/Redaction/components/AccordionRedaction/locales/pt.json": "874f",
	"./pages/Redaction/components/Credits/locales/en.json": "48ea",
	"./pages/Redaction/components/Credits/locales/es.json": "3556",
	"./pages/Redaction/components/Credits/locales/pt.json": "f615",
	"./pages/Redaction/components/FeedbackPermissionRedaction/locales/en.json": "168d",
	"./pages/Redaction/components/FeedbackPermissionRedaction/locales/es.json": "576a",
	"./pages/Redaction/components/FeedbackPermissionRedaction/locales/pt.json": "7214",
	"./pages/Redaction/components/ListDevelopedThemes/locales/en.json": "de7f",
	"./pages/Redaction/components/ListDevelopedThemes/locales/es.json": "5ebe",
	"./pages/Redaction/components/ListDevelopedThemes/locales/pt.json": "dd33",
	"./pages/Redaction/components/MyPerformance/locales/en.json": "e64c",
	"./pages/Redaction/components/MyPerformance/locales/es.json": "f63e",
	"./pages/Redaction/components/MyPerformance/locales/pt.json": "5754",
	"./pages/Redaction/components/RedactionPreview/locales/en.json": "93d9",
	"./pages/Redaction/components/RedactionPreview/locales/es.json": "7ced",
	"./pages/Redaction/components/RedactionPreview/locales/pt.json": "3486",
	"./pages/Redaction/components/TopRedaction/locales/en.json": "8d51",
	"./pages/Redaction/components/TopRedaction/locales/es.json": "028c",
	"./pages/Redaction/components/TopRedaction/locales/pt.json": "d965",
	"./pages/Redaction/locales/en.json": "0fc4",
	"./pages/Redaction/locales/es.json": "963b",
	"./pages/Redaction/locales/pt.json": "74bc",
	"./pages/Redaction/pages/CorrectionRedaction/components/ContentRedaction/locales/en.json": "7b47",
	"./pages/Redaction/pages/CorrectionRedaction/components/ContentRedaction/locales/es.json": "1d63",
	"./pages/Redaction/pages/CorrectionRedaction/components/ContentRedaction/locales/pt.json": "d011",
	"./pages/Redaction/pages/CorrectionRedaction/components/DissertationTopic/locales/en.json": "f844",
	"./pages/Redaction/pages/CorrectionRedaction/components/DissertationTopic/locales/es.json": "1d56",
	"./pages/Redaction/pages/CorrectionRedaction/components/DissertationTopic/locales/pt.json": "b4df",
	"./pages/Redaction/pages/CorrectionRedaction/components/HeaderCorrection/locales/en.json": "37291",
	"./pages/Redaction/pages/CorrectionRedaction/components/HeaderCorrection/locales/es.json": "0c5b",
	"./pages/Redaction/pages/CorrectionRedaction/components/HeaderCorrection/locales/pt.json": "7404",
	"./pages/Redaction/pages/CorrectionRedaction/components/ObservationRedaction/locales/en.json": "6bc1",
	"./pages/Redaction/pages/CorrectionRedaction/components/ObservationRedaction/locales/es.json": "03c7",
	"./pages/Redaction/pages/CorrectionRedaction/components/ObservationRedaction/locales/pt.json": "5114",
	"./pages/Redaction/pages/CorrectionRedaction/locales/en.json": "9d0f",
	"./pages/Redaction/pages/CorrectionRedaction/locales/es.json": "cda17",
	"./pages/Redaction/pages/CorrectionRedaction/locales/pt.json": "bb54",
	"./pages/Redaction/pages/InstructionRedaction/locales/en.json": "d0ca",
	"./pages/Redaction/pages/InstructionRedaction/locales/es.json": "1365",
	"./pages/Redaction/pages/InstructionRedaction/locales/pt.json": "8240",
	"./pages/Redaction/pages/MyRedactions/locales/en.json": "1dca",
	"./pages/Redaction/pages/MyRedactions/locales/es.json": "0a92",
	"./pages/Redaction/pages/MyRedactions/locales/pt.json": "e751",
	"./pages/Redaction/pages/NoteAThousandRedaction/components/HeaderAThousandRedaction/locales/en.json": "73ba",
	"./pages/Redaction/pages/NoteAThousandRedaction/components/HeaderAThousandRedaction/locales/es.json": "1ef4",
	"./pages/Redaction/pages/NoteAThousandRedaction/components/HeaderAThousandRedaction/locales/pt.json": "5e97",
	"./pages/Redaction/pages/NoteAThousandRedaction/locales/en.json": "1122",
	"./pages/Redaction/pages/NoteAThousandRedaction/locales/es.json": "83b7",
	"./pages/Redaction/pages/NoteAThousandRedaction/locales/pt.json": "4f87",
	"./pages/Redaction/pages/SendRedaction/locales/en.json": "8ac1",
	"./pages/Redaction/pages/SendRedaction/locales/es.json": "b66c",
	"./pages/Redaction/pages/SendRedaction/locales/pt.json": "425a",
	"./pages/Redaction/pages/TutorialRedaction/locales/en.json": "127b",
	"./pages/Redaction/pages/TutorialRedaction/locales/es.json": "b582",
	"./pages/Redaction/pages/TutorialRedaction/locales/pt.json": "c3bd",
	"./pages/RenewPlan/components/PaymentForm/locales/en.json": "119e",
	"./pages/RenewPlan/components/PaymentForm/locales/es.json": "f700",
	"./pages/RenewPlan/components/PaymentForm/locales/pt.json": "0b1a",
	"./pages/RenewPlan/locales/en.json": "bee2",
	"./pages/RenewPlan/locales/es.json": "92f8",
	"./pages/RenewPlan/locales/pt.json": "b4a5",
	"./pages/RenewPlan/pages/PaymentBillet/locales/en.json": "b1be",
	"./pages/RenewPlan/pages/PaymentBillet/locales/es.json": "9c41",
	"./pages/RenewPlan/pages/PaymentBillet/locales/pt.json": "61fd",
	"./pages/RenewPlan/pages/PaymentPix/locales/en.json": "4141",
	"./pages/RenewPlan/pages/PaymentPix/locales/es.json": "caba",
	"./pages/RenewPlan/pages/PaymentPix/locales/pt.json": "66a4",
	"./pages/RenewPlan/pages/PaymentSuccess/locales/en.json": "13a5",
	"./pages/RenewPlan/pages/PaymentSuccess/locales/es.json": "3a690",
	"./pages/RenewPlan/pages/PaymentSuccess/locales/pt.json": "8271",
	"./pages/RenewPlan/pages/PendencyDetail/locales/en.json": "9738",
	"./pages/RenewPlan/pages/PendencyDetail/locales/es.json": "e39d",
	"./pages/RenewPlan/pages/PendencyDetail/locales/pt.json": "7e9f",
	"./pages/RenewPlan/pages/ThankYouPayment/locales/en.json": "3d06",
	"./pages/RenewPlan/pages/ThankYouPayment/locales/es.json": "e205",
	"./pages/RenewPlan/pages/ThankYouPayment/locales/pt.json": "3553",
	"./pages/Shopping/components/AddressDetails/locales/en.json": "97d0",
	"./pages/Shopping/components/AddressDetails/locales/es.json": "9b0e",
	"./pages/Shopping/components/AddressDetails/locales/pt.json": "db6d",
	"./pages/Shopping/components/Banner/locales/en.json": "0e2a",
	"./pages/Shopping/components/Banner/locales/es.json": "3590",
	"./pages/Shopping/components/Banner/locales/pt.json": "31a61",
	"./pages/Shopping/components/BilletCode/locales/en.json": "b083",
	"./pages/Shopping/components/BilletCode/locales/es.json": "0e75",
	"./pages/Shopping/components/BilletCode/locales/pt.json": "bccf",
	"./pages/Shopping/components/BoxPaymentInstruction/locales/en.json": "0dbb",
	"./pages/Shopping/components/BoxPaymentInstruction/locales/es.json": "7617",
	"./pages/Shopping/components/BoxPaymentInstruction/locales/pt.json": "244b",
	"./pages/Shopping/components/BoxPaymentPrice/locales/en.json": "ca74",
	"./pages/Shopping/components/BoxPaymentPrice/locales/es.json": "27ca",
	"./pages/Shopping/components/BoxPaymentPrice/locales/pt.json": "9183",
	"./pages/Shopping/components/CardPhysicalProduct/locales/en.json": "fa45",
	"./pages/Shopping/components/CardPhysicalProduct/locales/es.json": "f7f4",
	"./pages/Shopping/components/CardPhysicalProduct/locales/pt.json": "be43",
	"./pages/Shopping/components/CardPlan/locales/en.json": "8289",
	"./pages/Shopping/components/CardPlan/locales/es.json": "61a5",
	"./pages/Shopping/components/CardPlan/locales/pt.json": "d43a",
	"./pages/Shopping/components/CardPlanBanner/locales/en.json": "e667",
	"./pages/Shopping/components/CardPlanBanner/locales/es.json": "2285",
	"./pages/Shopping/components/CardPlanBanner/locales/pt.json": "b65a",
	"./pages/Shopping/components/ContainerAccess/locales/en.json": "9d0c",
	"./pages/Shopping/components/ContainerAccess/locales/es.json": "504a",
	"./pages/Shopping/components/ContainerAccess/locales/pt.json": "9d89",
	"./pages/Shopping/components/ContainerPhysicalProduct/locales/en.json": "c384",
	"./pages/Shopping/components/ContainerPhysicalProduct/locales/es.json": "bd76",
	"./pages/Shopping/components/ContainerPhysicalProduct/locales/pt.json": "090d",
	"./pages/Shopping/components/ContainerPlans/locales/en.json": "5e4b",
	"./pages/Shopping/components/ContainerPlans/locales/es.json": "c41f",
	"./pages/Shopping/components/ContainerPlans/locales/pt.json": "d9d62",
	"./pages/Shopping/components/Descriptions/locales/en.json": "f332",
	"./pages/Shopping/components/Descriptions/locales/es.json": "b355",
	"./pages/Shopping/components/Descriptions/locales/pt.json": "1508",
	"./pages/Shopping/components/FormAddress/locales/en.json": "d177",
	"./pages/Shopping/components/FormAddress/locales/es.json": "5b53",
	"./pages/Shopping/components/FormAddress/locales/pt.json": "be44",
	"./pages/Shopping/components/FormBillet/locales/en.json": "42f7",
	"./pages/Shopping/components/FormBillet/locales/es.json": "144f",
	"./pages/Shopping/components/FormBillet/locales/pt.json": "c3f1",
	"./pages/Shopping/components/FormCreditCart/locales/en.json": "f8b0",
	"./pages/Shopping/components/FormCreditCart/locales/es.json": "545c",
	"./pages/Shopping/components/FormCreditCart/locales/pt.json": "221f",
	"./pages/Shopping/components/FormDiscount/locales/en.json": "b114",
	"./pages/Shopping/components/FormDiscount/locales/es.json": "aba1",
	"./pages/Shopping/components/FormDiscount/locales/pt.json": "af13",
	"./pages/Shopping/components/FormLogin/locales/en.json": "8fb6",
	"./pages/Shopping/components/FormLogin/locales/es.json": "4eec",
	"./pages/Shopping/components/FormLogin/locales/pt.json": "3399",
	"./pages/Shopping/components/FormPix/locales/en.json": "3431",
	"./pages/Shopping/components/FormPix/locales/es.json": "5fc3",
	"./pages/Shopping/components/FormPix/locales/pt.json": "1b12",
	"./pages/Shopping/components/FormRegister/locales/en.json": "2afb",
	"./pages/Shopping/components/FormRegister/locales/es.json": "33994",
	"./pages/Shopping/components/FormRegister/locales/pt.json": "43fe",
	"./pages/Shopping/components/FreeShipping/locales/en.json": "10f4",
	"./pages/Shopping/components/FreeShipping/locales/es.json": "9a7a8",
	"./pages/Shopping/components/FreeShipping/locales/pt.json": "7ceb",
	"./pages/Shopping/components/Highlight/locales/en.json": "4ce1",
	"./pages/Shopping/components/Highlight/locales/es.json": "dcea",
	"./pages/Shopping/components/Highlight/locales/pt.json": "a75e",
	"./pages/Shopping/components/MethodsPayment/locales/en.json": "7634",
	"./pages/Shopping/components/MethodsPayment/locales/es.json": "354e",
	"./pages/Shopping/components/MethodsPayment/locales/pt.json": "592b",
	"./pages/Shopping/components/ModalCanceledPayment/locales/en.json": "e290",
	"./pages/Shopping/components/ModalCanceledPayment/locales/es.json": "3342",
	"./pages/Shopping/components/ModalCanceledPayment/locales/pt.json": "1152",
	"./pages/Shopping/components/ModalDescriptionsPlan/locales/en.json": "d6c0",
	"./pages/Shopping/components/ModalDescriptionsPlan/locales/es.json": "a849",
	"./pages/Shopping/components/ModalDescriptionsPlan/locales/pt.json": "d915",
	"./pages/Shopping/components/PaymentForm/locales/en.json": "7eb4",
	"./pages/Shopping/components/PaymentForm/locales/es.json": "4038",
	"./pages/Shopping/components/PaymentForm/locales/pt.json": "2bf6",
	"./pages/Shopping/components/Pendency/locales/en.json": "80df",
	"./pages/Shopping/components/Pendency/locales/es.json": "de9a",
	"./pages/Shopping/components/Pendency/locales/pt.json": "8fb8",
	"./pages/Shopping/components/PixCode/locales/en.json": "7e5a",
	"./pages/Shopping/components/PixCode/locales/es.json": "01b8",
	"./pages/Shopping/components/PixCode/locales/pt.json": "ce69",
	"./pages/Shopping/components/PlanTypes/locales/en.json": "6fec",
	"./pages/Shopping/components/PlanTypes/locales/es.json": "6b1e",
	"./pages/Shopping/components/PlanTypes/locales/pt.json": "36f3",
	"./pages/Shopping/components/ProgressPayment/locales/en.json": "19d3",
	"./pages/Shopping/components/ProgressPayment/locales/es.json": "321e",
	"./pages/Shopping/components/ProgressPayment/locales/pt.json": "5465",
	"./pages/Shopping/components/PurchaseDetails/locales/en.json": "9391",
	"./pages/Shopping/components/PurchaseDetails/locales/es.json": "b25ca",
	"./pages/Shopping/components/PurchaseDetails/locales/pt.json": "7071",
	"./pages/Shopping/components/PurchaseSummary/locales/en.json": "8d2d",
	"./pages/Shopping/components/PurchaseSummary/locales/es.json": "35e55",
	"./pages/Shopping/components/PurchaseSummary/locales/pt.json": "d5a9",
	"./pages/Shopping/components/ShopContainer/locales/en.json": "8597",
	"./pages/Shopping/components/ShopContainer/locales/es.json": "790a",
	"./pages/Shopping/components/ShopContainer/locales/pt.json": "107c",
	"./pages/Shopping/components/ThankYou/locales/en.json": "c691",
	"./pages/Shopping/components/ThankYou/locales/es.json": "fdec",
	"./pages/Shopping/components/ThankYou/locales/pt.json": "b841",
	"./pages/Shopping/components/WarningPaymentPendency/locales/en.json": "8b05",
	"./pages/Shopping/components/WarningPaymentPendency/locales/es.json": "b781",
	"./pages/Shopping/components/WarningPaymentPendency/locales/pt.json": "543b",
	"./pages/Shopping/constants/locales/en.json": "af13b",
	"./pages/Shopping/constants/locales/es.json": "e644",
	"./pages/Shopping/constants/locales/pt.json": "7b4c",
	"./pages/Shopping/locales/en.json": "3baa",
	"./pages/Shopping/locales/es.json": "5816",
	"./pages/Shopping/locales/pt.json": "ddb2",
	"./pages/Shopping/pages/Descriptive/components/Marketing/locales/en.json": "6a93",
	"./pages/Shopping/pages/Descriptive/components/Marketing/locales/es.json": "7391",
	"./pages/Shopping/pages/Descriptive/components/Marketing/locales/pt.json": "0c93",
	"./pages/Shopping/pages/Descriptive/components/PlanBanner/locales/en.json": "4158",
	"./pages/Shopping/pages/Descriptive/components/PlanBanner/locales/es.json": "958f",
	"./pages/Shopping/pages/Descriptive/components/PlanBanner/locales/pt.json": "c215",
	"./pages/Shopping/pages/Descriptive/locales/en.json": "3fdc",
	"./pages/Shopping/pages/Descriptive/locales/es.json": "5c6e",
	"./pages/Shopping/pages/Descriptive/locales/pt.json": "105b",
	"./pages/Shopping/pages/Payment/locales/en.json": "2d29",
	"./pages/Shopping/pages/Payment/locales/es.json": "62bd",
	"./pages/Shopping/pages/Payment/locales/pt.json": "26cba",
	"./pages/Shopping/pages/PaymentBillet/locales/en.json": "9ef1",
	"./pages/Shopping/pages/PaymentBillet/locales/es.json": "bb5a",
	"./pages/Shopping/pages/PaymentBillet/locales/pt.json": "f9a0",
	"./pages/Shopping/pages/PaymentPix/locales/en.json": "7d93",
	"./pages/Shopping/pages/PaymentPix/locales/es.json": "aac1",
	"./pages/Shopping/pages/PaymentPix/locales/pt.json": "43e88",
	"./pages/Shopping/pages/Pendencies/locales/en.json": "9274",
	"./pages/Shopping/pages/Pendencies/locales/es.json": "6513",
	"./pages/Shopping/pages/Pendencies/locales/pt.json": "29c4",
	"./pages/Shopping/pages/PendencyDetail/locales/en.json": "1289",
	"./pages/Shopping/pages/PendencyDetail/locales/es.json": "09e2",
	"./pages/Shopping/pages/PendencyDetail/locales/pt.json": "8ee3",
	"./pages/Shopping/pages/ThankYouPayment/locales/en.json": "d610",
	"./pages/Shopping/pages/ThankYouPayment/locales/es.json": "772a",
	"./pages/Shopping/pages/ThankYouPayment/locales/pt.json": "83e4",
	"./pages/Simulated/components/BoxSimulator/locales/en.json": "07fc",
	"./pages/Simulated/components/BoxSimulator/locales/es.json": "9092",
	"./pages/Simulated/components/BoxSimulator/locales/pt.json": "730f",
	"./pages/Simulated/components/ContainerAccordionSimulated/locales/en.json": "d98c",
	"./pages/Simulated/components/ContainerAccordionSimulated/locales/es.json": "03ef",
	"./pages/Simulated/components/ContainerAccordionSimulated/locales/pt.json": "a8d4",
	"./pages/Simulated/components/ContainerButtonsInstruction/locales/en.json": "7cae",
	"./pages/Simulated/components/ContainerButtonsInstruction/locales/es.json": "caeb",
	"./pages/Simulated/components/ContainerButtonsInstruction/locales/pt.json": "c4e7",
	"./pages/Simulated/components/CourseWeight/locales/en.json": "e0c7",
	"./pages/Simulated/components/CourseWeight/locales/es.json": "aa3b",
	"./pages/Simulated/components/CourseWeight/locales/pt.json": "2d46",
	"./pages/Simulated/components/Modals/locales/en.json": "0306",
	"./pages/Simulated/components/Modals/locales/es.json": "4f55",
	"./pages/Simulated/components/Modals/locales/pt.json": "c0f2",
	"./pages/Simulated/components/SelectChoice/constants/locales/en.json": "15f4",
	"./pages/Simulated/components/SelectChoice/constants/locales/es.json": "3d22",
	"./pages/Simulated/components/SelectChoice/constants/locales/pt.json": "fa0b",
	"./pages/Simulated/components/SelectChoice/locales/en.json": "6b54",
	"./pages/Simulated/components/SelectChoice/locales/es.json": "e437",
	"./pages/Simulated/components/SelectChoice/locales/pt.json": "e0a8d",
	"./pages/Simulated/components/SidebarSimulated/locales/en.json": "beb3",
	"./pages/Simulated/components/SidebarSimulated/locales/es.json": "af49",
	"./pages/Simulated/components/SidebarSimulated/locales/pt.json": "e2bc",
	"./pages/Simulated/components/SidebarSimulatedQuestions/locales/en.json": "f45e0",
	"./pages/Simulated/components/SidebarSimulatedQuestions/locales/es.json": "f70c",
	"./pages/Simulated/components/SidebarSimulatedQuestions/locales/pt.json": "2b42",
	"./pages/Simulated/components/SimulatedDayButtons/locales/en.json": "6feb4",
	"./pages/Simulated/components/SimulatedDayButtons/locales/es.json": "b5c9",
	"./pages/Simulated/components/SimulatedDayButtons/locales/pt.json": "212c",
	"./pages/Simulated/components/SimulatorResultAccordion/locales/en.json": "5d21",
	"./pages/Simulated/components/SimulatorResultAccordion/locales/es.json": "c6b9",
	"./pages/Simulated/components/SimulatorResultAccordion/locales/pt.json": "828b",
	"./pages/Simulated/components/SimulatorResultContent/locales/en.json": "a7a1",
	"./pages/Simulated/components/SimulatorResultContent/locales/es.json": "d9a0",
	"./pages/Simulated/components/SimulatorResultContent/locales/pt.json": "1055",
	"./pages/Simulated/components/SisuScore/locales/en.json": "df63",
	"./pages/Simulated/components/SisuScore/locales/es.json": "7628",
	"./pages/Simulated/components/SisuScore/locales/pt.json": "d270",
	"./pages/Simulated/components/constants/locales/en.json": "3dec",
	"./pages/Simulated/components/constants/locales/es.json": "deef",
	"./pages/Simulated/components/constants/locales/pt.json": "deb2",
	"./pages/Simulated/constants/locales/en.json": "1f45",
	"./pages/Simulated/constants/locales/es.json": "84ae",
	"./pages/Simulated/constants/locales/pt.json": "90d8",
	"./pages/Simulated/locales/en.json": "0966",
	"./pages/Simulated/locales/es.json": "3d3f",
	"./pages/Simulated/locales/pt.json": "86b4",
	"./pages/Simulated/pages/EnemSimulator/locales/en.json": "f572",
	"./pages/Simulated/pages/EnemSimulator/locales/es.json": "52f4",
	"./pages/Simulated/pages/EnemSimulator/locales/pt.json": "c0ab",
	"./pages/Simulated/pages/ListSimulations/locales/en.json": "eb89",
	"./pages/Simulated/pages/ListSimulations/locales/es.json": "0fde",
	"./pages/Simulated/pages/ListSimulations/locales/pt.json": "a250",
	"./pages/Simulated/pages/OtherSimulated/locales/en.json": "7f16",
	"./pages/Simulated/pages/OtherSimulated/locales/es.json": "b1df",
	"./pages/Simulated/pages/OtherSimulated/locales/pt.json": "4bb7",
	"./pages/Simulated/pages/SimulatedQuestion/locales/en.json": "3912",
	"./pages/Simulated/pages/SimulatedQuestion/locales/es.json": "0ec9",
	"./pages/Simulated/pages/SimulatedQuestion/locales/pt.json": "2860",
	"./pages/Simulated/pages/SimulatedResult/components/ContainerQuestionResult/locales/en.json": "97f6",
	"./pages/Simulated/pages/SimulatedResult/components/ContainerQuestionResult/locales/es.json": "0825",
	"./pages/Simulated/pages/SimulatedResult/components/ContainerQuestionResult/locales/pt.json": "fa6a",
	"./pages/Simulated/pages/SimulatedResult/components/MyResult/locales/en.json": "9aaf",
	"./pages/Simulated/pages/SimulatedResult/components/MyResult/locales/es.json": "5984",
	"./pages/Simulated/pages/SimulatedResult/components/MyResult/locales/pt.json": "ec22",
	"./pages/Simulated/pages/SimulatedResult/locales/en.json": "0c90",
	"./pages/Simulated/pages/SimulatedResult/locales/es.json": "a3d3",
	"./pages/Simulated/pages/SimulatedResult/locales/pt.json": "6390",
	"./pages/Simulated/pages/SimulatorResult/locales/en.json": "6e94",
	"./pages/Simulated/pages/SimulatorResult/locales/es.json": "0ff8",
	"./pages/Simulated/pages/SimulatorResult/locales/pt.json": "c8e4",
	"./pages/Simulated/pages/TutorialSimulated/locales/en.json": "aeff",
	"./pages/Simulated/pages/TutorialSimulated/locales/es.json": "d99c",
	"./pages/Simulated/pages/TutorialSimulated/locales/pt.json": "ad2f",
	"./pages/Video/components/ButtonsActions/locales/en.json": "4295",
	"./pages/Video/components/ButtonsActions/locales/es.json": "3a13",
	"./pages/Video/components/ButtonsActions/locales/pt.json": "480c",
	"./pages/Video/components/FeedbackCredits/locales/en.json": "ad89",
	"./pages/Video/components/FeedbackCredits/locales/es.json": "3cf8",
	"./pages/Video/components/FeedbackCredits/locales/pt.json": "60a8",
	"./pages/Video/components/FilterButton/locales/en.json": "0b82",
	"./pages/Video/components/FilterButton/locales/es.json": "2a9c",
	"./pages/Video/components/FilterButton/locales/pt.json": "92d9",
	"./pages/Video/components/FilterClass/locales/en.json": "e7cd",
	"./pages/Video/components/FilterClass/locales/es.json": "65b6",
	"./pages/Video/components/FilterClass/locales/pt.json": "e243",
	"./pages/Video/components/PlayerMessages/locales/en.json": "f814",
	"./pages/Video/components/PlayerMessages/locales/es.json": "e14b",
	"./pages/Video/components/PlayerMessages/locales/pt.json": "c1d0",
	"./pages/Video/components/VideoList/locales/en.json": "f4ba",
	"./pages/Video/components/VideoList/locales/es.json": "e3a6",
	"./pages/Video/components/VideoList/locales/pt.json": "fff1",
	"./pages/Video/locales/en.json": "e00a",
	"./pages/Video/locales/es.json": "b86d",
	"./pages/Video/locales/pt.json": "69f7",
	"./pages/Video/pages/TutorialVideos/locales/en.json": "66fb",
	"./pages/Video/pages/TutorialVideos/locales/es.json": "aac13",
	"./pages/Video/pages/TutorialVideos/locales/pt.json": "6089",
	"./pages/War/components/Card/locales/en.json": "853f",
	"./pages/War/components/Card/locales/es.json": "0690",
	"./pages/War/components/Card/locales/pt.json": "6dce",
	"./pages/War/components/GeneralAlert/locales/en.json": "d007",
	"./pages/War/components/GeneralAlert/locales/es.json": "2f6a",
	"./pages/War/components/GeneralAlert/locales/pt.json": "45cd",
	"./pages/War/components/Leveling/components/Buttons/locales/en.json": "5d7d",
	"./pages/War/components/Leveling/components/Buttons/locales/es.json": "9be87",
	"./pages/War/components/Leveling/components/Buttons/locales/pt.json": "5f4a",
	"./pages/War/components/Leveling/locales/en.json": "6e36",
	"./pages/War/components/Leveling/locales/es.json": "1492",
	"./pages/War/components/Leveling/locales/pt.json": "453d",
	"./pages/War/components/LevelingResults/components/Message/locales/en.json": "fa3d",
	"./pages/War/components/LevelingResults/components/Message/locales/es.json": "9d29",
	"./pages/War/components/LevelingResults/components/Message/locales/pt.json": "ccf2",
	"./pages/War/components/LevelingResults/locales/en.json": "0360",
	"./pages/War/components/LevelingResults/locales/es.json": "aeba",
	"./pages/War/components/LevelingResults/locales/pt.json": "c1bb",
	"./pages/War/components/MapHover/locales/en.json": "a565",
	"./pages/War/components/MapHover/locales/es.json": "b420",
	"./pages/War/components/MapHover/locales/pt.json": "0d52",
	"./pages/War/components/Mission/components/Buttons/locales/en.json": "09ad",
	"./pages/War/components/Mission/components/Buttons/locales/es.json": "128e",
	"./pages/War/components/Mission/components/Buttons/locales/pt.json": "38d9",
	"./pages/War/components/Mission/components/Message/locales/en.json": "7a90",
	"./pages/War/components/Mission/components/Message/locales/es.json": "da46",
	"./pages/War/components/Mission/components/Message/locales/pt.json": "17b6",
	"./pages/War/components/Mission/components/ResultModal/locales/en.json": "bc4c",
	"./pages/War/components/Mission/components/ResultModal/locales/es.json": "b74e",
	"./pages/War/components/Mission/components/ResultModal/locales/pt.json": "40c1",
	"./pages/War/components/Mission/locales/en.json": "37f4",
	"./pages/War/components/Mission/locales/es.json": "4ec6",
	"./pages/War/components/Mission/locales/pt.json": "01da",
	"./pages/War/components/MissionCard/locales/en.json": "8340",
	"./pages/War/components/MissionCard/locales/es.json": "988b",
	"./pages/War/components/MissionCard/locales/pt.json": "d1bb",
	"./pages/War/components/ModalMessageCaracter/locales/en.json": "601c",
	"./pages/War/components/ModalMessageCaracter/locales/es.json": "206a",
	"./pages/War/components/ModalMessageCaracter/locales/pt.json": "77ab",
	"./pages/War/components/Modals/Character/locales/en.json": "2f83",
	"./pages/War/components/Modals/Character/locales/es.json": "770c",
	"./pages/War/components/Modals/Character/locales/pt.json": "36bb",
	"./pages/War/components/Modals/Question/locales/en.json": "0e9c",
	"./pages/War/components/Modals/Question/locales/es.json": "ca86",
	"./pages/War/components/Modals/Question/locales/pt.json": "ab4b",
	"./pages/War/components/Modals/Redaction/locales/en.json": "0087",
	"./pages/War/components/Modals/Redaction/locales/es.json": "e47e",
	"./pages/War/components/Modals/Redaction/locales/pt.json": "5cfb",
	"./pages/War/components/SidebarCard/locales/en.json": "45a2",
	"./pages/War/components/SidebarCard/locales/es.json": "ac14",
	"./pages/War/components/SidebarCard/locales/pt.json": "16ab",
	"./pages/War/components/TrainingSteps/components/ModalInfo/locales/en.json": "7c62",
	"./pages/War/components/TrainingSteps/components/ModalInfo/locales/es.json": "4851",
	"./pages/War/components/TrainingSteps/components/ModalInfo/locales/pt.json": "9ba9",
	"./pages/War/components/TrainingSteps/locales/en.json": "c594",
	"./pages/War/components/TrainingSteps/locales/es.json": "76b7",
	"./pages/War/components/TrainingSteps/locales/pt.json": "8c11",
	"./pages/War/components/WorldCard/locales/en.json": "9e2ad",
	"./pages/War/components/WorldCard/locales/es.json": "d4f8",
	"./pages/War/components/WorldCard/locales/pt.json": "fcc6",
	"./pages/War/locales/en.json": "0c2a",
	"./pages/War/locales/es.json": "e1ba",
	"./pages/War/locales/pt.json": "b2e7",
	"./pages/War/pages/Config/components/AcceptSwitch/locales/en.json": "ff1c",
	"./pages/War/pages/Config/components/AcceptSwitch/locales/es.json": "d723",
	"./pages/War/pages/Config/components/AcceptSwitch/locales/pt.json": "d15a",
	"./pages/War/pages/Config/components/Configuration/locales/en.json": "3c81",
	"./pages/War/pages/Config/components/Configuration/locales/es.json": "a5d2",
	"./pages/War/pages/Config/components/Configuration/locales/pt.json": "487b",
	"./pages/War/pages/Config/components/SelectConfig/components/ListConfig/locales/en.json": "c8bd",
	"./pages/War/pages/Config/components/SelectConfig/components/ListConfig/locales/es.json": "6e4d",
	"./pages/War/pages/Config/components/SelectConfig/components/ListConfig/locales/pt.json": "f600",
	"./pages/War/pages/Config/components/SelectConfig/locales/en.json": "1b06",
	"./pages/War/pages/Config/components/SelectConfig/locales/es.json": "e068",
	"./pages/War/pages/Config/components/SelectConfig/locales/pt.json": "c4303",
	"./pages/War/pages/Config/locales/en.json": "9b93",
	"./pages/War/pages/Config/locales/es.json": "8adc",
	"./pages/War/pages/Config/locales/pt.json": "89f2",
	"./pages/War/pages/Headquarters/locales/en.json": "772c",
	"./pages/War/pages/Headquarters/locales/es.json": "cf8d",
	"./pages/War/pages/Headquarters/locales/pt.json": "2d51",
	"./pages/War/pages/Launch/locales/en.json": "97e7",
	"./pages/War/pages/Launch/locales/es.json": "0d7a",
	"./pages/War/pages/Launch/locales/pt.json": "bd3d",
	"./pages/War/pages/Leveling/components/Message/locales/en.json": "0b075",
	"./pages/War/pages/Leveling/components/Message/locales/es.json": "9c27",
	"./pages/War/pages/Leveling/components/Message/locales/pt.json": "70d1",
	"./pages/War/pages/Leveling/locales/en.json": "3d7a",
	"./pages/War/pages/Leveling/locales/es.json": "eff0",
	"./pages/War/pages/Leveling/locales/pt.json": "b0cd",
	"./pages/War/pages/LevelingResult/locales/en.json": "7cf5",
	"./pages/War/pages/LevelingResult/locales/es.json": "5d2d",
	"./pages/War/pages/LevelingResult/locales/pt.json": "4f5d",
	"./pages/War/pages/MissionListResult/locales/en.json": "2abb",
	"./pages/War/pages/MissionListResult/locales/es.json": "2ac4",
	"./pages/War/pages/MissionListResult/locales/pt.json": "7272",
	"./pages/War/pages/TrainingCenter/components/CustomizeMission/locales/en.json": "06cd",
	"./pages/War/pages/TrainingCenter/components/CustomizeMission/locales/es.json": "b8cf",
	"./pages/War/pages/TrainingCenter/components/CustomizeMission/locales/pt.json": "75c6",
	"./pages/War/pages/TrainingCenter/locales/en.json": "f076",
	"./pages/War/pages/TrainingCenter/locales/es.json": "1daa",
	"./pages/War/pages/TrainingCenter/locales/pt.json": "39e0",
	"./pages/War/pages/TutorialWar/locales/en.json": "e0ff",
	"./pages/War/pages/TutorialWar/locales/es.json": "892a",
	"./pages/War/pages/TutorialWar/locales/pt.json": "f193",
	"./pages/War/pages/WarRoom/components/ModalCard/locales/en.json": "34b9",
	"./pages/War/pages/WarRoom/components/ModalCard/locales/es.json": "8099",
	"./pages/War/pages/WarRoom/components/ModalCard/locales/pt.json": "c22d",
	"./pages/War/pages/WarRoom/locales/en.json": "9294",
	"./pages/War/pages/WarRoom/locales/es.json": "20ab",
	"./pages/War/pages/WarRoom/locales/pt.json": "8522",
	"./pages/War/pages/Welcome/components/ChooseCharacter/locales/en.json": "df4f",
	"./pages/War/pages/Welcome/components/ChooseCharacter/locales/es.json": "04bc",
	"./pages/War/pages/Welcome/components/ChooseCharacter/locales/pt.json": "f517",
	"./pages/War/pages/Welcome/components/Message/locales/en.json": "9bc1",
	"./pages/War/pages/Welcome/components/Message/locales/es.json": "2edf",
	"./pages/War/pages/Welcome/components/Message/locales/pt.json": "ba79",
	"./pages/War/pages/Welcome/components/Welcome/locales/en.json": "f008",
	"./pages/War/pages/Welcome/components/Welcome/locales/es.json": "8fce",
	"./pages/War/pages/Welcome/components/Welcome/locales/pt.json": "648d",
	"./pages/War/pages/Welcome/locales/en.json": "97cc",
	"./pages/War/pages/Welcome/locales/es.json": "0d5c",
	"./pages/War/pages/Welcome/locales/pt.json": "0151",
	"./widgets/News/ListNews/locales/en.json": "bb38",
	"./widgets/News/ListNews/locales/es.json": "679a",
	"./widgets/News/ListNews/locales/pt.json": "5a99",
	"./widgets/Products/SaleOfProducts/locales/en.json": "11d2",
	"./widgets/Products/SaleOfProducts/locales/es.json": "373b",
	"./widgets/Products/SaleOfProducts/locales/pt.json": "9a50",
	"./widgets/Users/RealtimeUsers/locales/en.json": "8aea",
	"./widgets/Users/RealtimeUsers/locales/es.json": "e19c",
	"./widgets/Users/RealtimeUsers/locales/pt.json": "9153",
	"./widgets/Util/Paragraph/locales/en.json": "75be",
	"./widgets/Util/Paragraph/locales/es.json": "cf97",
	"./widgets/Util/Paragraph/locales/pt.json": "dabe",
	"./widgets/Util/Search/locales/en.json": "d125",
	"./widgets/Util/Search/locales/es.json": "7646",
	"./widgets/Util/Search/locales/pt.json": "298f",
	"./widgets/Video/LastListVideos/locales/en.json": "7eaa",
	"./widgets/Video/LastListVideos/locales/es.json": "0daf",
	"./widgets/Video/LastListVideos/locales/pt.json": "0998",
	"./widgets/Video/LastVideo/locales/en.json": "8ca4",
	"./widgets/Video/LastVideo/locales/es.json": "c416",
	"./widgets/Video/LastVideo/locales/pt.json": "8df6",
	"./widgets/Video/ListVideos/locales/en.json": "ef5f",
	"./widgets/Video/ListVideos/locales/es.json": "d6fc",
	"./widgets/Video/ListVideos/locales/pt.json": "fec8",
	"./widgets/Video/PlayerVideo/locales/en.json": "f1b7",
	"./widgets/Video/PlayerVideo/locales/es.json": "ec17",
	"./widgets/Video/PlayerVideo/locales/pt.json": "a727"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67a1";